import './global/cookies'

if (typeof svg4everybody !== 'undefined') {
    svg4everybody();
}

var references;

$.fn.select2.amd.define("CustomDropdownAdapter", [
    "select2/utils",
    "select2/dropdown",
    "select2/dropdown/attachBody",
    "select2/dropdown/attachContainer",
    "select2/dropdown/search",
    "select2/dropdown/minimumResultsForSearch",
    "select2/dropdown/closeOnSelect",
],
function(Utils, Dropdown, AttachBody, AttachContainer, Search, MinimumResultsForSearch, CloseOnSelect) {
    // Decorate Dropdown with Search functionalities
    let dropdownWithSearch = Utils.Decorate(Dropdown, Search);

    dropdownWithSearch.prototype.render = function() {
        // Copy and modify default search render method
        var $rendered = Dropdown.prototype.render.call(this);

        var $selectResults = $rendered.find('.select2-results');

        $selectResults.wrap('<div class="select2-results--wrapper js-select2-wrapper"></div>')
            .wrap('<div class="select2-results--data js-select2-data"></div>');

        $rendered.find('.js-select2-data').prepend(`<h2>
            <span class="select2-data-title">${translations.products}</span>
            <span class="select2-data-total js-select2-totals"></span>
            <span class="select2-view-all js-select2-view-all"></span>
        </h2>`);

        $rendered.find('.js-select2-data').append(`<div class="select2-results__option select2-results__message js-empty-resultset"></div>`);

        $rendered.find('.js-select2-wrapper').prepend(`<div class="select2-results--suggestions">
            <h2>${translations.suggestions}</h2>

            <div class="select2-suggestions__wrap">
                <div class="select2-suggestions">
                    <ul class="search-icons js-search-suggestions">

                    </ul>

                    <div class="hide js-category-suggestions-wrapper">
                        <h3>${translations.categories}</h3>
                        <ul class="js-category-suggestions">

                        </ul>
                    </div>

                    <div class="hide js-brand-suggestions-wrapper">
                        <h3>${translations.brands}</h3>
                        <ul class="js-brand-suggestions">

                        </ul>
                    </div>
                </div>
            </div>
        </div>`);

        // Add ability for a placeholder in the search box
        let placeholder = this.options.get("placeholderForSearch") || "";
        var $search = $(
            '<span class="select2-search select2-search--dropdown">' +
            '<input class="select2-search__field" placeholder="' + placeholder + '" type="search"' +
            ' tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off"' +
            ' spellcheck="false" role="textbox" />' +
            '</span>'
        );

        this.$searchContainer = $search;
        this.$search = $search.find('input');

        $rendered.prepend($search);

        return $rendered;
    };

    // Decorate the dropdown+search with necessary containers
    let adapter = Utils.Decorate(dropdownWithSearch, AttachContainer);
    adapter = Utils.Decorate(adapter, AttachBody);

    return adapter;
});

var select2Templates = {
    search: function(state) {
        if (!state.id) {
            return state.text;
        }

        var elem = $(state.element);
        if (state.image) {
            elem.attr('data-image', state.image);
        }
        if (state.pretty_url) {
            elem.attr('data-url', state.pretty_url);
        }

        var elemHtml = '';
        if (showProductAvailibity) {
            elemHtml += '<a href="' + state.pretty_url + '" class="product__box product__box--has-availability">';
        } else {
            elemHtml += '<a href="' + state.pretty_url + '" class="product__box">';
        }
            elemHtml += '<div class="product__box-badges">';
            if (state.price_data && state.price_data.brutto_discount) {
                elemHtml += '<div class="product__box-badge product__box-badge--sale"><span>' + translations.on_sale + '</span></div>';
            }
            if (state.is_new_product) {
                elemHtml += '<div class="product__box-badge product__box-badge--new"><span>' + translations.new + '</span></div>';
            }
            if (state.is_top_product) {
                elemHtml += '<div class="product__box-badge product__box-badge--top"><span>' + translations.top + '</span></div>';
            }
            elemHtml += '</div>';

            elemHtml += '<div class="product__box-top">';
                elemHtml += '<div class="product__box-image">';
                    elemHtml += '<span><picture class="' + (state.media.length <= 0 ? 'nopic' : '') + '"><img src="' + state.image + '" /></picture></span>';
                elemHtml += '</div>';
            elemHtml += '</div>';

            elemHtml += '<div class="product__box-content">';

                elemHtml += '<div class="product__box-content-section">';
                    elemHtml += '<div class="product__box-title">' + (state.highlight || state.text) + '</div>';
                    elemHtml += '<div class="product__box-code">' + (state.highlightCode || state.code) + '</div>';
                elemHtml += '</div>';

                if (state.price_data && state.price_data.brutto_price && state.price_data.brutto_price > 0) {
                    elemHtml += '<div class="product__box-content-section product__box-content-section--price">';

                        elemHtml += '<div class="product__price">';
                            if (state.price_data.brutto_discount) {
                                elemHtml += '<div class="product__price--old"><span class="product__price--old-price">' + state.price_data.formatted.original_brutto_price + '</span> ' + currency + '</div>';
                            }
                            elemHtml += '<div class="product__price-wrapper">';
                                elemHtml += '<div class="product__price--current">' + state.price_data.formatted.brutto_price + ' ' + currency + '</div>';
                            elemHtml += '</div>';

                        elemHtml += '</div>';

                    elemHtml += '</div>';
                }

                if (showProductAvailibity && !(isBookableProductsEnabled && state.is_bookable)) {
                    elemHtml += '<div class="product__box-content-section product__box-content-section--availability">';

                        elemHtml += '<div class="product__box-availability product__box-availability--';
                            if (state.total_quantity > 0) {
                                elemHtml += 'on-stock">' + erdsoft.svgIcon({name: 'checkmark'}) + ' ' + translations.on_stock;
                                if (showProductStock) {
                                    elemHtml += ' (' + state.total_quantity + ')';
                                }
                            } else {
                                if (isPreorderEnabled && !state.can_be_added_to_cart) {
                                    elemHtml += 'out-of-stock">' + erdsoft.svgIcon({ name: 'truck' }) + ' ' + translations.on_request;
                                } else {
                                    elemHtml += 'out-of-stock">' + erdsoft.svgIcon({ name: 'cross2' }) + ' ' + translations.out_of_stock;
                                }
                            }
                        elemHtml += '</div>';

                    elemHtml += '</div>';
                }

            elemHtml += '</div>';

        elemHtml += '</a>';

        var newFormat = $(elemHtml);

        return newFormat;
    }
}

if ($().block) {
    $.blockUI.defaults.message = '<i class="loading"></i>';
    $.blockUI.defaults.overlayCSS = {
        backgroundColor: '#fff',
        opacity: 0.8,
        cursor: 'wait'
    };
    $.blockUI.defaults.css = {
        width: 16,
        border: 0,
        padding: 0,
        backgroundColor: 'transparent'
    };
}

erdsoft = (function () {
    var options = {
        firstResize: true,
        heroFirstResize: true,
        currentWidth: null,
        lastWidth: 9999,
        scrollbarWidth: null,
        baseMobileBreakpoint: 1199,
        mobileBreakpoint: 1199,
        modal: null,
        openedModals: [],
        cache: {},
        webp: false,
        view: 'mobile',
        scrollPosition: 0,
        mobileNavOpen: false,
        pluginsLoaded: {
            jconfirm: false,
            floatLabels: false,
        },
        jconfirmLoaded: {
            css: false,
            js: false,
            full: false,
        },
        viewport: {
            width: null,
            height: null,
        },
        sticky: false,
        floatLabelInstance: null,
        stickyFiltersStyle: null,
        stickyFiltersTop: 0,
        siteWrapperMargin: null,
        stickyElements: ['.js-sticky-sidebar'],
    };

    // private interface
    var getScrollBarWidth = function () {
        var inner = document.createElement('p');
        inner.style.width = '100%';
        inner.style.height = '200px';

        var outer = document.createElement('div');
        outer.style.position = 'absolute';
        outer.style.top = '0px';
        outer.style.left = '0px';
        outer.style.visibility = 'hidden';
        outer.style.width = '200px';
        outer.style.height = '150px';
        outer.style.overflow = 'hidden';
        outer.appendChild(inner);

        document.body.appendChild(outer);
        var w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var w2 = inner.offsetWidth;

        if (w1 == w2) {
            w2 = outer.clientWidth;
        }

        document.body.removeChild(outer);

        return w1 - w2;
    };

    var initDropdowns = function () {
        $('.js-dropdown-toggle').each( function() {
            hoverintent(
                $(this)[0],
                function() {
                    if (options.view === 'desktop') {
                        var dropdown = $('.js-dropdown-items', this);
                        dropdown.fadeIn(300);
                    }
                },
                function() {
                    if (options.view === 'desktop') {
                        var dropdown = $('.js-dropdown-items', this);
                        dropdown.fadeOut(300);
                    }
                }
            ).options({
                timeout: 200,
            });
        });
    };

    var initSubnavs = function() {
        $('.js-subnav').closest('li').addClass('nav__subnav-parent js-subnav-parent');

        $('.js-subnav-parent:not(.inited) > a, .js-subnav-parent:not(.inited) > button').each(function() {
            var $this = $(this);
            var svgCaretDown = { name: themeSettings.dropdown_arrow ?? 'chevron-down' };

            $this.closest('.js-subnav-parent').addClass('inited');
            $this.append('<span class="nav__toggle js-toggle-subnav">' + erdsoft.svgIcon(svgCaretDown) + '</span>');
            if ($this.closest('.menu__dropdown').length) {
                $this.children('.js-toggle-subnav').append(erdsoft.svgIcon({ name: 'angle-right' }));
            }
            if (!$this.closest('.js-category-nav-parent').length) {
                $this.addClass('menu__dropdown-parent');
            }
        });

        $('.js-subnav-parent.inited').each( function() {
            if (!($(this).hasClass('js-subnav-open-with-click') || $(this).hasClass('js-subnav-no-hover'))) {
                hoverintent(
                    $(this)[0],
                    function() {
                        if (options.view === 'desktop') {
                            var subnav = $(this).children('.js-subnav');

                            if (
                                $(this).closest('.js-subnav').length &&
                                (!(themeSettings.open_categories_on_click ?? false) || !$(this).closest('.js-category-nav-parent').length)
                            ) {
                                var subnavParentPos = $(this).position();
                                var subnavParentList = $(this).parent();
                                var scrollPosition = subnavParentList.scrollTop();
                                var firstSiblingPos = subnavParentList.children().eq(0).position();
                                var subnavTopBorderWidth = subnav.css('border-top-width').replace('px', '');
                                var subnavTopOffset = subnavParentPos.top - scrollPosition - firstSiblingPos.top - subnavTopBorderWidth;
                                if (subnavTopOffset < 0) {
                                    subnavTopOffset = subnavTopBorderWidth * -1;
                                }
                                subnav.css('top', subnavTopOffset);
                            }

                            erdsoft.layoutMasonry();

                            $(this).addClass('active');
                            subnav.addClass('subnav-is-open');
                            if (!(themeSettings.open_categories_on_click ?? false) || !$(this).closest('.js-category-nav-parent').length) {
                                subnav.children('ul').css('max-height', $(window).height() - (subnav.offset().top - $(window).scrollTop()) - 50);
                            }
                        }
                    },
                    function() {
                        if (options.view === 'desktop') {
                            var subnav = $(this).children('.js-subnav');
                            $(this).removeClass('active');
                            subnav.removeClass('subnav-is-open');
                        }
                    }
                ).options({
                    timeout: 200,
                });
            }
        });

        checkNavLinksOverflow();
    }

    var initMainNav = function () {
        $('.js-categories-wrapper .js-subnav').closest('li').addClass('js-subnav-open-with-click');

        $('body').on('click', '.js-open-mobile-nav', function(e) {
            e.preventDefault();
            var targetMenu = $(this).data('menu');
            $('button[data-tabhref="' + targetMenu + '"]').trigger('click');
            options.cache['navWrapper'].addClass('drawer--open');
            $('html').addClass('overflow');
        }).on('click', '.js-close-drawer, .js-drawer-overlay', function() {
            $('html').removeClass('overflow');
            $(this).closest('.js-drawer').removeClass('drawer--open');
        }).on('click', '.js-toggle-subnav', function(e) {
            var toggleElem = $(this);
            toggleSubnav(toggleElem, e);
        }).on('click', '.js-toggle-subnav-on-parent', function(e) {
            var toggleElem = $(this).children('.js-toggle-subnav');
            toggleSubnav(toggleElem, e);
        }).on('click', '.js-nav-wrapper a:not(.js-trigger-modal)', function(e) {
            e.stopPropagation();
        });

        function toggleSubnav(toggleElem, e) {
            var subnav = toggleElem.closest('li');
            e.preventDefault();
            if (options.view === 'mobile' || subnav.hasClass('js-subnav-open-with-click')) {
                e.preventDefault();
                e.stopPropagation();

                var subnav = toggleElem.closest('li');
                var subSubnav = subnav.find('> .js-subnav');
                if (subnav.hasClass('js-subnav-opened')) {
                    toggleElem.removeClass('nav__toggle--rotate');
                    subSubnav.slideUp(300, function() {
                        subnav.removeClass('js-subnav-opened');
                    });
                }
                else {
                    toggleElem.addClass('nav__toggle--rotate');
                    subSubnav.slideDown(300, function(){
                        subnav.addClass('js-subnav-opened');
                    });
                }
            }
        }
        initSubnavs();

        $('.js-nav-wrapper .selected').parentsUntil('.js-nav-wrapper', 'li').addClass('selected');
        $('.js-categories-wrapper .selected').parentsUntil('.js-categories-wrapper', 'li').addClass('selected');
    };

    var getAndInitMainNav = function(tryCounter = 1) {
        var navBarContainers = $('.js-load-category-nav');
        if (navBarContainers.length) {
            if (tryCounter >= 3) {
                return;
            }

            $.ajax({
                type: 'POST',
                url: navBarContainers.first().data('url'),
                dataType: 'json',
                success: function (response) {
                    $.each(response.nav_bars, function (key, categoryHtml) {
                        navBarContainers.filter('[data-key="' + key + '"]').replaceWith(categoryHtml);
                    })

                    if (
                        themeSettings.show_categories_by_default
                        && $('body').hasClass('home')
                        && $('body').hasClass('with-slider')
                    ) {
                        $('.js-category-nav-parent').addClass('default-open');
                    }

                    if (selectedMenu === 'products') {
                        var currentMenuItem = $('.js-category-nav-wrap').find('[data-id="' + selectedColumn + '"]');
                        var currentMobileMenuItem = $('#productmenu').find('[data-id="' + selectedColumn + '"]');

                        if (currentMenuItem.length) {
                            currentMenuItem.addClass('selected');
                        }

                        if (currentMobileMenuItem.length) {
                            currentMobileMenuItem.addClass('selected');
                        }
                    }

                    initMainNav();
                },
                error: function () {
                    getAndInitMainNav(++ tryCounter);
                },
            });
        } else {
            initMainNav();
        }
    };

    var initDesktopSlidingNav = function() {
        if (options.view === 'desktop') {
            $('.js-subnav').removeAttr('style');

            $('.js-categories-wrapper .js-subnav-parent').each( function() {
                $(this).removeClass('js-subnav-opened')
                    .find('> a > .js-toggle-subnav')
                        .removeClass('nav__toggle--rotate');
            });

            $('.js-categories-wrapper .selected').each( function() {
                $(this)
                    .closest('.js-subnav-parent')
                        .addClass('js-subnav-opened')
                        .find('> a > .js-toggle-subnav')
                            .addClass('nav__toggle--rotate');
            });
        }
    };

    var initMobileNav = function() {
        if (options.view === 'mobile') {
            $('.js-subnav').removeAttr('style');

            $('.js-nav-wrapper .js-subnav-parent, .js-categories-wrapper .js-subnav-parent').each( function() {
                $(this).removeClass('js-subnav-opened')
                    .find('> a > .js-toggle-subnav')
                        .removeClass('nav__toggle--rotate');
            });

            $('.js-nav-wrapper .selected, .js-categories-wrapper .selected').each( function() {
                $(this)
                    .closest('.js-subnav-parent')
                        .addClass('js-subnav-opened')
                        .find('> a > .js-toggle-subnav')
                            .addClass('nav__toggle--rotate');
            });
        }
    };

    var initCartWidget = function() {
        // Open cart widget
        $('body').on('click', '.js-cart-widget-click', function() {
            if(!$('.js-cart-widget-body').hasClass('cart-widget-is-open') && options.view === 'desktop') {
                $('.js-cart-widget-body').addClass('cart-widget-is-open');
                moveChatWidget();
            }
        });

        // Close cart widget
        $('body').on('click', '.js-cart-widget-close', function() {
            $('.js-cart-widget-body').removeClass('cart-widget-is-open');
            moveChatWidget();
        });
    };

    var moveChatWidget = function() {
        var chatWidget = options.cache['body'].children('.widget-visible');

        if (chatWidget.length) {
            // Move chat widget so it stays under the cart widget
            chatWidget.detach().appendTo('.site-wrap').attr('style', 'z-index: 98 !important');
        } else if ($('.site-wrap').find('.widget-visible')) {
            // Move the chat widget back to original position
            chatWidget = $('.site-wrap').find('.widget-visible');
            chatWidget.detach().appendTo(options.cache['body']).removeAttr('style');
        }
    }

    var addToCartFixed = function() {
        var fixedElem = $('.js-add-to-cart-fixed');
        if (fixedElem.length) {
            var fixedElemHeight = fixedElem.outerHeight();
            options.cache['body'].find('.site-wrap').css('padding-bottom', fixedElemHeight);
        }
    };

    var initFilterOverlay = function() {
        $('.js-show-mobile-filters').on('click', function(e) {
            e.preventDefault();
            $('html').addClass('overflow');
            options.cache['filterWrapper'].addClass('drawer--open');
        });
    };

    var initSearch = function() {
        options.cache['search'] = $('.js-search');

        $('.js-open-search').on('click', function(e) {
            e.preventDefault();

            // prevent content shift when scrollbar disappears
            $('html').addClass('overflow');

            adjustElementsOnModalOpen();

            options.cache['search'].fadeIn(300);

            $('.js-search-select').select2('focus');
            $('.js-search-select').select2('open');
        });

        options.cache['search'].on('click', function(e) {
            if (!$(e.target).closest('.js-search-select2').length) {
                closeSearch();
            }
        });

        $('.js-search-select').on('select2:close', function() {
            closeSearch();
        });

        options.cache['search'].find('.js-search-modal').on('click', function(e) {
            e.stopPropagation();
        });
    };

    var closeSearch = function() {
        options.cache['search'].fadeOut(300, function() {
            $('.js-search-select.select2-hidden-accessible').select2('close');
            $('html').removeClass('overflow');
            adjustElementsOnModalClose();
        });
    }

    var setFiltersHeight = function(el) {
        el.css('height', options.cache['window'].height() - options.stickyFiltersTop - 20);
    }

    var initPoll = function() {
        $('.js-poll-show-results').on('click', function() {
            var parent = $(this).closest('.js-poll-form');
            erdsoft.showVoteResults({voted: false}, parent);
        });

        $('.js-poll-radio').on('change', function() {
            var poll_wrapper = $(this).closest('.js-poll');
            var poll = $('.js-poll-form', poll_wrapper);
            poll.trigger('submit');
        });

        $('.js-poll-show-form').on('click', function() {
            var poll_wrapper = $(this).closest('.js-poll');
            var results = $('.js-poll-results', poll_wrapper);
            var form = $('.js-poll-form', poll_wrapper);
            results.slideUp();
            form.slideDown();
        });
    };

    var initJconfirm = function(setup) {
        options.pluginsLoaded.jconfirm = true;
        erdsoft.openModal(setup);
    };

    var initLoadedFloatLabels = function() {
        $('form.js-do-float input, form select, form textarea').not('.js-float-labeled').each( function() {
            var this_elem = $(this);
            if (this_elem.attr('id')) {
                var thisElementId = this_elem.attr('id');
                $(this)
                .prev('label')
                .attr('for', thisElementId)
                .addClass('js-float-labeled');
            }
            else {
                var thisElementName = this_elem.attr('name');
                $(this)
                .attr('for', thisElementName)
                .prev('label')
                .attr('for', thisElementName)
                .addClass('js-float-labeled');
            }
        });
        if (options.floatLabelInstance) {
            options.floatLabelInstance.rebuild();
        }
        options.floatLabelInstance = new FloatLabels('form.js-do-float', {
            // options go here
            prioritize: 'placeholder',
            inputRegex: /email|number|password|search|tel|text|url|date|file/,
        });
    };

    var initModals = function () {
        options.cache['body'].on('click', '.js-trigger-modal', function (e) {
            e.preventDefault();

            var modalTrigger = $(this);
            var modalSetup = {};

            if (modalTrigger.hasClass('js-close-modals')) {
                erdsoft.closeModals();
            }

            if (typeof modalTrigger.data('modal-type') !== 'undefined') {
                modalSetup.type = modalTrigger.data('modal-type');
            }

            if (typeof modalTrigger.data('modal-href') !== 'undefined') {
                modalSetup.content = 'url:' + modalTrigger.data('modal-href');
                modalSetup.backgroundDismiss = false;
            }

            if (typeof modalTrigger.data('modal-class') !== 'undefined') {
                modalSetup.columnClass = modalTrigger.data('modal-class');
            }

            if (typeof modalTrigger.data('modal-width') !== 'undefined') {
                modalSetup.boxWidth = modalTrigger.data('modal-width');
            }

            if (typeof modalTrigger.data('modal-theme') !== 'undefined') {
                modalSetup.theme = modalTrigger.data('modal-theme');
            }

            modalSetup.customModal = true;

            erdsoft.openModal(modalSetup);
        });
    };

    var modalLoaded = function () {
        initLoadedFloatLabels();
    };

    function centerModal() {
        $('.jconfirm-box-container').each( function() {
            setTimeout(() => {
                $(this).addClass('animation-done');
            }, 500);
        });
    }

    var swiperEnableDisable = function(swiperInstance, swiperParent) {
        swiperParent = swiperParent || $(swiperInstance.el);
        const $swiperParentWrapper = swiperParent.parent();

        if (swiperParent.find('.swiper-slide').not('.swiper-slide-duplicate').length <= swiperInstance.params.slidesPerView) {
            swiperParent.find('.swiper-button-next, .swiper-button-prev, .swiper-pagination, .swiper-slide-duplicate').each(function() {
                $(this)[0].style.setProperty('display', 'none', 'important')
            });

            $swiperParentWrapper.find('.carousel__pagination, .carousel__nav, .carousel-button-next, .carousel-button-prev').each(function() {
                $(this)[0].style.setProperty('display', 'none', 'important')
            });
        } else {
            swiperParent.find('.swiper-button-next, .swiper-button-prev, .swiper-pagination, .swiper-slide-duplicate').each(function() {
                $(this)[0].style.removeProperty('display');
            });

            $swiperParentWrapper.find('.carousel__pagination, .carousel__nav, .carousel-button-next, .carousel-button-prev').each(function() {
                $(this)[0].style.removeProperty('display');
            });
        }

        setTimeout(function() {
            swiperInstance.el.classList.remove('loading');
            swiperInstance.update();
        }, 400);
    }

    // Check the navigation links (strictly the links, the cart elements, logo etc. are not included) for overflow
    // If an element is overflowing, append a dropdown menu (if the dropdown doesn't exist yet) and put it in the dropdown
    // If for some reason the screen get's resized and there is enough room for an item, remove it from the dropdown and put it back in the navigation
    function checkNavLinksOverflow() {
        let navbar = $('.js-nav-wrapper'),
            navList = navbar.find('ul').first(),
            navItems = [],
            itemsToMove = [];

        return function () {
            navbar.css('flex-grow', '1');

            let navElements = navList.find('>li'),
                navElementsWidth = Math.floor(Number(
                    navElements
                        .toArray()
                        .reduce((accumulator, elem) => accumulator + $(elem).outerWidth(true), 0)
                ) * 100) / 100,
                dropdownItem = $('.js-dynamic-dropdown'),
                dropdownTriggerWidth = 0;

            if (navElementsWidth > navList.width() && !$('.js-dynamic-dropdown').length) {
                appendDropdownTrigger(navList);
                dropdownTriggerWidth = dropdownItem.outerWidth(true);
                navElementsWidth += dropdownTriggerWidth;
            }

            $(navElements.get().reverse()).each(function () {
                let item = $(this),
                    navItem,
                    itemToMove;

                if (navElementsWidth > navList.width()) {
                    if (item.hasClass('js-dynamic-dropdown')) {
                        // the dynamic dropdown gets appended as the last element of the navigation,
                        // which means it would get moved to itself if there's further overflow
                        // to avoid this, we are skipping it and moving the second to last item.
                        itemToMove = item.prev();
                        return;
                    } else {
                        itemToMove = item;
                    }

                    if (itemToMove.hasClass('js-category-nav-wrap')) {
                        // skip the category nav if for some reason it gets in our way
                        return;
                    }

                    navItem = {
                        item: itemToMove,
                        currentWidth: itemToMove.outerWidth(true), // adding the current width so later we can calculate if it would fit in the nav
                    };

                    navElementsWidth -= itemToMove.outerWidth(true);
                    navItems.push(navItem);
                    itemsToMove.unshift(itemToMove);
                }
            });

            if (navItems.length) {
                const currentItem = navItems[navItems.length - 1];
                let currentItemWidth = currentItem.currentWidth;

                if (!currentItem) {
                    navbar.removeAttr('style');
                    return;
                }

                if (navItems.length === 1) {
                    dropdownTriggerWidth = dropdownItem.outerWidth(true);
                    currentItemWidth -= dropdownTriggerWidth;
                }

                // checking if the first item of the dynamic dropdown could fit in the navigation
                if (navElementsWidth + currentItemWidth < navList.width()) {
                    appendDropdownItems(itemsToMove.shift());
                    appendNavItems(currentItem, navItems);

                    // after moving the first item back in the main navigation we need to check if another item also could fit
                    checkNavLinksOverflow();
                }
            }

            if (itemsToMove.length) {
                appendDropdownItems(itemsToMove);
            }

            navbar.removeAttr('style');
        };
    }

    var removeItemFromArray = function (item, array) {
        const index = array.indexOf(item);

        if (index !== -1) {
            array.splice(index, 1);
        }
    };

    var appendNavItems = function (itemToAppend, itemsArray) {
        if (!itemToAppend) {
            return;
        }

        const navElement = itemToAppend.item;

        navElement.insertBefore($('.js-dynamic-dropdown'));

        if (navElement.hasClass('js-subnav-parent')) {
            const dropdownIconWrapper = navElement.find(
                '>a .js-toggle-subnav, >button .js-toggle-subnav'
            );
            const svgCaretDown = {
                name: themeSettings.dropdown_arrow ?? 'chevron-down',
            };

            // resetting positioning so it won't cause issues
            navElement.find('.js-subnav').first().css('top', '');
            changeDropdownIcon(dropdownIconWrapper, svgCaretDown);
        }

        removeItemFromArray(itemToAppend, itemsArray);

        if (!itemsArray.length) {
            removeDynamicDropdown($('.js-dynamic-dropdown'));
        }
    };

    var changeDropdownIcon = function (iconWrapper, icon) {
        if (!iconWrapper.length || !Object.keys(icon).length) {
            return;
        }
        iconWrapper.empty().append(erdsoft.svgIcon(icon));
    };

    var removeDynamicDropdown = function (dynamicDropdown) {
        if (!dynamicDropdown.length) {
            return;
        }

        dynamicDropdown.remove();
    };

    var appendDropdownItems = function (dropdownItems) {
        const dropdown = $('.js-dynamic-dropdown .js-dropdown');

        if (!dropdown.length) {
            return;
        }

        dropdown.append(dropdownItems);
        checkForAppendedSubnavs(dropdown);
    };

    var checkForAppendedSubnavs = function (dropdown) {
        if (!dropdown.length) {
            return;
        }

        const subnavParents = dropdown.find('>.js-subnav-parent');
        if (!subnavParents.length) {
            return;
        }

        subnavParents.each(function () {
            const subnavParent = $(this);
            const subnavIconWrapper = subnavParent.find('>a .js-toggle-subnav, >button .js-toggle-subnav');

            changeDropdownIcon(subnavIconWrapper, { name: 'angle-right' });
        });
    };

    var appendDropdownTrigger = function (navList) {
        let dropdownTrigger = $('.js-dynamic-dropdown');

        if (dropdownTrigger.length) {
            return;
        }

        dropdownTrigger =
            $(`<li class="nav__subnav-parent dynamic-dropdown js-subnav-parent js-dynamic-dropdown">
                <button class="menu__dropdown-parent">
                    ${erdsoft.svgIcon({ name: 'menu3' })}
                </button>
                <div class="menu__dropdown js-subnav">
                    <ul class="js-dropdown">
                    </ul>
                </div>
            </li>`);

        dropdownTrigger.appendTo(navList);
        checkNavLinksOverflow();
        initSubnavs();
    };

    var checkNavLinksOverflow = checkNavLinksOverflow();

    function readSwiperAutoPlayOption(element) {
        var element = $(element);

        if (!element.length) {
            return {};
        }
        var autoplayDelay = element.data('autoplay-delay') || 0;
        if (!autoplayDelay) {
            return {};
        }
        return {
            autoplay: {
                delay: autoplayDelay * 1000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true
            }
        }
    }

    var initSlider = function(carousel) {
        var carouselEl = carousel[0];
        if (carouselEl.querySelectorAll('.swiper-slide').length > 1) {
            var isHero = !!carouselEl.closest('.js-hero');
            var prevArrow = carouselEl.parentNode.querySelector('.js-prev-arrow');
            var nextArrow = carouselEl.parentNode.querySelector('.js-next-arrow');
            var pagination = carouselEl.parentNode.querySelector('.js-swiper-pagination');

            // autoplay options setup
            var autoPlayOptions = readSwiperAutoPlayOption(carousel);

            var defaultSwiper = new Swiper (carouselEl, {
                loop: true,
                lazyPreloadPrevNext: isHero ? 1 : 0,
                autoHeight: isHero,
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow
                },
                pagination: {
                    el: pagination,
                    dynamicBullets: true,
                    clickable: true
                },
                on: {
                    init: function () {
                        swiperEnableDisable(this, carousel);
                        $(prevArrow).empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_left ?? 'chevron-thin-left'}));
                        $(nextArrow).empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_right ?? 'chevron-thin-right'}));
                        if (isHero) {
                            carousel.find('.swiper-slide.inactive').removeClass('inactive');
                        }
                        carouselEl.classList.remove('loading');
                    },
                    breakpoint: function() {
                        swiperEnableDisable(this, carousel);
                    }
                },
                ...autoPlayOptions
            });
        } else {
            carousel.removeClass('loading');
        }
    }

    var initCarousel = function(carousel) {
        var carouselEl = carousel[0];
        var totalSlides = carousel.find('.swiper-slide').length;
        if (totalSlides > 0) {
            var slidesPerView = themeSettings.carousel_slides_per_view;

            if (carousel.closest('.js-page-wrapper--medium').length) {
                slidesPerView = themeSettings.carousel_slides_per_view_medium;
            }

            if (carousel.data('slides')) {
                slidesPerView = carousel.data('slides');
            }

            if (carousel.closest('.js-contact-gallery').length && themeSettings.contact_carousel_slides_per_view) {
                slidesPerView = themeSettings.contact_carousel_slides_per_view;
            }

            var slidesPerView530 = slidesPerView > 2 ? 2 : 1;
            var slidesPerView830 = slidesPerView > 2 ? 3 : slidesPerView;

            var defaultCarousel = new Swiper (carouselEl, {
                loop: totalSlides > 1 ? true : false,
                slidesPerView: 1,
                spaceBetween: themeSettings.carousel_gap ?? 20,
                pagination: {
                    el: carouselEl.closest('.js-carousel-wrap').querySelector('.js-swiper-pagination'),
                    dynamicBullets: true,
                    clickable: true
                },
                navigation: {
                    nextEl: carouselEl.closest('.js-carousel-wrap').querySelector('.js-next-arrow'),
                    prevEl: carouselEl.closest('.js-carousel-wrap').querySelector('.js-prev-arrow')
                },
                breakpoints: {
                    530: {
                        slidesPerView: slidesPerView530,
                        loop: totalSlides > slidesPerView530 ? true : false
                    },
                    830: {
                        slidesPerView: slidesPerView830,
                        loop: totalSlides > slidesPerView830 ? true : false
                    },
                    1600: {
                        slidesPerView: slidesPerView,
                        loop: totalSlides > slidesPerView ? true : false
                    }
                },
                on: {
                    init: function() {
                        swiperEnableDisable(this, carousel);
                        carousel.closest('.js-carousel-wrap').find('.js-prev-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_left_small ?? (themeSettings.carousel_nav_arrow_left ?? 'chevron-thin-left')}));
                        carousel.closest('.js-carousel-wrap').find('.js-next-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_right_small ?? (themeSettings.carousel_nav_arrow_right ?? 'chevron-thin-right')}));
                    },
                    breakpoint: function() {
                        swiperEnableDisable(this, carousel);
                    }
                }
            });
        }
    }

    var productsCarousel = function(el) {
        var init = false;

        var carousel = el;
        var carouselEl = carousel[0];
        var productsCarousel;
        var totalSlides = carousel.find('.swiper-slide').length;

        var slidesPerView = themeSettings.products_carousel_slides_per_view ?? 4;

        carousel.closest('.js-tab').show();

        if (carousel.closest('.js-page-wrapper--medium').length) {
            slidesPerView = themeSettings.products_carousel_slides_per_view_medium ?? 4;
        }

        if (carousel.data('slides')) {
            slidesPerView = carousel.data('slides');
        }

        var slidesPerView530 = slidesPerView > 2 ? 2 : slidesPerView;
        var slidesPerView768 = slidesPerView > 4 ? slidesPerView - 3 : slidesPerView > 2 ? 2 : slidesPerView;
        var slidesPerView1024 = slidesPerView > 4 ? slidesPerView - 2 : slidesPerView > 3 ? 3 : slidesPerView;
        var slidesPerView1366 = slidesPerView > 4 ? slidesPerView - 1 : slidesPerView;

        function initProductsCarousel() {
            if (!carousel.hasClass('js-mobile-carousel') || window.innerWidth < 768) {
                carousel.find('.products__list').addClass('swiper-wrapper').removeClass('products__list products__list--grid');
                if (!init) {
                    productsCarousel = new Swiper (carouselEl, {
                        loop: totalSlides > 1 ? true : false,
                        slidesPerView: 1,
                        spaceBetween: themeSettings.products_carousel_gap ?? 20,
                        pagination: {
                            el: carouselEl.closest('.js-carousel-wrapper').querySelector('.js-swiper-pagination'),
                            dynamicBullets: true,
                            clickable: true
                        },
                        navigation: {
                            nextEl: carouselEl.closest('.js-carousel-wrapper').querySelector('.js-next-arrow'),
                            prevEl: carouselEl.closest('.js-carousel-wrapper').querySelector('.js-prev-arrow')
                        },
                        breakpoints: {
                            530: {
                                slidesPerView: slidesPerView530,
                                loop: totalSlides > slidesPerView530 ? true : false
                            },
                            768: {
                                slidesPerView: slidesPerView768,
                                loop: totalSlides > slidesPerView768 ? true : false
                            },
                            1024: {
                                slidesPerView: slidesPerView1024,
                                loop: totalSlides > slidesPerView1024 ? true : false
                            },
                            1366: {
                                slidesPerView: slidesPerView1366,
                                loop: totalSlides > slidesPerView1366 ? true : false
                            },
                            1600: {
                                slidesPerView: slidesPerView,
                                loop: totalSlides > slidesPerView ? true : false
                            }
                        },
                        on: {
                            init: function() {
                                carousel.closest('.js-carousel-wrapper').find('.js-prev-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_left_small ?? (themeSettings.carousel_nav_arrow_left ?? 'chevron-thin-left')}));
                                carousel.closest('.js-carousel-wrapper').find('.js-next-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_right_small ?? (themeSettings.carousel_nav_arrow_right ?? 'chevron-thin-right')}));
                                init = true;
                                swiperEnableDisable(this, carousel);

                                carousel.closest('.js-tab').on('tabActivated', function() {
                                    productsCarousel.update();
                                });
                            },
                            breakpoint: function() {
                                swiperEnableDisable(this, carousel);
                            }
                        },
                    });
                }
            } else {
                if (init) {
                    productsCarousel.destroy(true, true);
                    carousel.siblings('.carousel__pagination').empty().hide();
                    init = false;
                } else {
                    carousel.removeClass('loading');
                }
                carousel.find('.swiper-wrapper').addClass('products__list products__list--grid').removeClass('swiper-wrapper');
            }
        }

        initProductsCarousel();
        window.addEventListener("resize", initProductsCarousel);
    }

    var initProductGallery = function (gallery) {
        var galleryEl = gallery[0];
        var thumbs = galleryEl.closest('section').querySelector('.js-product-thumbnails');
        var productThumbsOrientation = themeSettings.product_details_thumbnails_direction ?? 'vertical';

        if (typeof(thumbs) != 'undefined' && thumbs != null) {
            var productGalleryThumbs = new Swiper (thumbs, {
                slidesPerView: 3,
                spaceBetween: themeSettings.product_thumbnails_gap ?? 10,
                pagination: false,
                direction: 'horizontal',
                navigation: {
                    nextEl: thumbs.parentNode.querySelector('.js-thumbs-next'),
                    prevEl: thumbs.parentNode.querySelector('.js-thumbs-prev')
                },
                breakpoints: {
                    460: {
                        direction: 'horizontal',
                        slidesPerView: 4
                    },
                    570: {
                        direction: 'horizontal',
                        slidesPerView: 5
                    },
                    680: {
                        direction: 'horizontal',
                        slidesPerView: 6
                    },
                    768: {
                        direction: 'vertical',
                        slidesPerView: 'auto'
                    },
                    1200: {
                        direction: productThumbsOrientation,
                        slidesPerView: 'auto'
                    }
                }
            });
        }

        if (gallery.find('.swiper-slide').length > 1) {
            var productGallerySlider = new Swiper (galleryEl, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 1,
                pagination: false,
                navigation: false,
                thumbs: {
                    swiper: productGalleryThumbs,
                }
            });
        }
    }

    var initAccordions = function (accordionWrapper = $('.js-accordion'), accordionHeader = '.js-accordion-header', accordionContent = '.js-accordion-content') {
        if (!accordionWrapper.length) return;
        if (!accordionWrapper.find(accordionHeader).length) return;

        let header = accordionWrapper.find(accordionHeader);

        header.on('click', function () {
            let content = $(this).siblings(accordionContent);
            if (!content.length) return;

            if ($(this).hasClass('js-hide')) {
                return $(this).hide(0, function () {
                    content.slideToggle('fast');
                })
            }

            $(this).toggleClass('open')
            content.slideToggle('fast');
        })
    }

    var initBrands = function () {
        var slidesPerView = themeSettings.brands_carousel_slides_per_view ?? 4;
        var spaceBetweenDesktop = themeSettings.brands_carousel_gap_desktop ?? themeSettings.brands_carousel_gap ?? 20;
        var spaceBetweenMobile = themeSettings.brands_carousel_gap ?? 20;

        var brandsEl = document.querySelector('.js-brands');

        if ($('.js-brands').length) {
            // autoplay options setup
            var autoPlayOptions = readSwiperAutoPlayOption(brandsEl);

            var totalSlides = $('.js-brands').find('.swiper-slide').length;
            var slidesPerView1400 = slidesPerView > 6 ? slidesPerView - 2 : slidesPerView;
            var slidesPerView1600 = slidesPerView > 6 ? slidesPerView - 1 : slidesPerView;

            var brandsSlider = new Swiper('.js-brands', {
                loop: totalSlides > 2 ? true : false,
                slidesPerView: 2,
                spaceBetween: spaceBetweenMobile,
                freeMode: {
                    enabled: true,
                    sticky: true
                },
                pagination: {
                    el: brandsEl.querySelector('.js-swiper-pagination'),
                    dynamicBullets: true,
                    clickable: true
                },
                navigation: {
                    nextEl: brandsEl.querySelector('.js-next-arrow'),
                    prevEl: brandsEl.querySelector('.js-prev-arrow')
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    480: {
                        slidesPerView: 3,
                        spaceBetween: spaceBetweenMobile,
                        loop: totalSlides > 3 ? true : false,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: spaceBetweenDesktop,
                        loop: totalSlides > 4 ? true : false,
                    },
                    1080: {
                        freeMode: false,
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: spaceBetweenDesktop,
                        loop: totalSlides > 5 ? true : false,
                    },
                    1400: {
                        freeMode: false,
                        slidesPerView: slidesPerView1400,
                        slidesPerGroup: slidesPerView1400,
                        spaceBetween: spaceBetweenDesktop,
                        loop: totalSlides > slidesPerView1400 ? true : false,
                    },
                    1600: {
                        freeMode: false,
                        slidesPerView: slidesPerView1600,
                        slidesPerGroup: slidesPerView1600,
                        spaceBetween: spaceBetweenDesktop,
                        loop: totalSlides > slidesPerView1600 ? true : false,
                    },
                    1800: {
                        freeMode: false,
                        slidesPerView: slidesPerView,
                        slidesPerGroup: slidesPerView,
                        spaceBetween: spaceBetweenDesktop,
                        loop: totalSlides > slidesPerView ? true : false,
                    }
                },
                on: {
                    init: function() {
                        $('.js-brands').find('.js-prev-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_left_small ?? (themeSettings.carousel_nav_arrow_left ?? 'chevron-thin-left')}));
                        $('.js-brands').find('.js-next-arrow').empty().append(erdsoft.svgIcon({name: themeSettings.carousel_nav_arrow_right_small ?? (themeSettings.carousel_nav_arrow_right ?? 'chevron-thin-right')}));
                    }
                },
                ...autoPlayOptions
            });
        }
    }

    var adjustElementsForModal = function (maxWidth, centerOfPage) {
        $('.js-header').css('max-width', maxWidth);

        if($('.side-banners__wrap').length) {
            $('.side-banners__wrap').css({
                'left': centerOfPage,
                'max-width': maxWidth
            });
        }
    }

    var adjustElementsOnModalOpen = function () {
        // keep sticky sidebar in position while scrollbar is disabled
        erdsoft.handleStickySidebars();

        if($('.jconfirm-box, .js-search-select2').length) {
            var scrollBarWidth = window.innerWidth - $('.js-footer').width();
            var pageWidth = window.innerWidth - scrollBarWidth;
            var centerOfPage = pageWidth / 2;
            var maxWidth = pageWidth;

            adjustElementsForModal(maxWidth, centerOfPage);
        }
    }

    var adjustElementsOnModalClose = function () {
        erdsoft.handleStickySidebars();
        adjustElementsForModal('100%', '50%');
    }

    var setBottomNav = function () {
        if ($('.js-pager-wrapper').closest('.js-bottom-nav').length) {
            const offset = $('.js-pager-wrapper').siblings('.js-back-button').outerWidth(true);
            $('.js-pager-wrapper').css('margin-right', offset);
        }
    }

    var setSiteWrapperMargin = function(siteWrapperSelector, headerItemSelector) {
        // Get the elements matching the selectors
        var $siteWrapper = $(siteWrapperSelector);
        var $headerItem = $(headerItemSelector);

        // Check if elements matching the selectors exist in the DOM
        if (!$siteWrapper.length || !$headerItem.length) {
            return;
        }

        // Get the current height of the header
        var newHeight = $headerItem.outerHeight();
        var currentMarginTop = parseInt($siteWrapper.css('margin-top'), 10);

        options.siteWrapperMargin = newHeight;

        if (currentMarginTop !== newHeight) {
            // Set the new height as the margin-top value for the site wrapper
            $siteWrapper.css('margin-top', newHeight + 'px');
        }
    }

    var setEqualHeights = function (el) {
        var itemsLength = [];

        el.children().css('height', 'auto');

        // find max. number of items
        el.each(function() {
            itemsLength.push($(this).children().length);
        });
        var maxItems = Math.max.apply(0, itemsLength);

        for (var i = 0; i < maxItems; i++) {
            // collect items heights
            var heights = [];
            el.each(function() {
                heights.push($(this).children().eq(i).outerHeight());
            });

            // find largest height and apply it to other elements what are on same index
            var largestHeight = Math.max.apply(0, heights);
            el.each(function() {
                $(this).children().eq(i).css('height', largestHeight);
            });
        }
    }

    var handleStickyFilters = function() {
        if (options.cache['filterWrapperInner'].length) {
            var stickyFiltersEl = options.cache['filterWrapperInner'].closest('.js-sticky-sidebar');
            var isFiltersElStuck = isStickyElStuck(stickyFiltersEl[0]);
            var isScrollbarNeeded = isFiltersElStuck
                && options.view === 'desktop'
                && $('.js-filter-form').outerHeight() > (options.cache['window'].height() - options.stickyFiltersTop - 20);

            stickyFiltersEl[0].classList.toggle('is-sticky', isScrollbarNeeded);
            if (isScrollbarNeeded) {
                setFiltersHeight(options.cache['filterWrapperInner']);
            } else {
                options.cache['filterWrapperInner'].removeAttr('style');
            }
        }
    }

    var isStickyElStuck = function(el) {
        if (!options.stickyFiltersStyle) {
            options.stickyFiltersStyle = window.getComputedStyle(el);
            options.stickyFiltersTop = parseInt(options.stickyFiltersStyle.top, 10);
        }

        const currentTop = el.getBoundingClientRect().top;
        return (currentTop <= options.stickyFiltersTop);
    }

    var setMarqueeSpeed = function () {
        $('.js-bar-marquee').each(function () {
            var marqueeContainer = $(this);
            var marqueeContent = marqueeContainer.find('p');
            var contentWidth = marqueeContent.width();
            var containerWidth = marqueeContainer.width();
            var loopDistance = contentWidth + containerWidth;
            var baseSpeed = 80;
            var loopTime = loopDistance / baseSpeed

            marqueeContent.css('animation', `info-marquee ${loopTime}s linear infinite`);
        });
    }

    function getReservationSlots(url, startDate, direction) {
        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json',
            data: {
                start_date: startDate,
                direction: direction
            },
            beforeSend: function() {
                $('.js-booking-calendar').block();
            },
            complete: function() {
                $('.js-booking-calendar').unblock();
            },
            success: function (response) {
                if (response.status == 'success' && response.html != 'undefined') {
                    $('.js-booking-slots-container').html(response.html);
                    $('.js-booking-slots-container').data('startOfWeek', response.startOfWeekData);
                    $('.js-booking-week-start').html(response.startOfWeek);
                    $('.js-booking-week-end').html(response.endOfWeek);
                } else {
                    erdsoft.openModal({
                        type: 'alert',
                        content: translations.booking_slots_load_error,
                        buttons: 'Ok'
                    });
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                erdsoft.openModal({
                    type: 'alert',
                    content: translations.booking_slots_load_error,
                    buttons: 'Ok'
                });
            }
        });
    }

    var loadCSS = function(url) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
    }

    var initFlatpickr = function() {
        loadCSS('/css/optional/flatpickr.min.css');

        requireWithFallback(
            'flatpickrLang',
            asset_path + 'js/optional/flatpickr/l10n/' + app_lang + '.js',
            asset_path + 'js/optional/flatpickr/l10n/' + fallback_lang + '.js',
            function(isFallback) {
                if (!isFallback) {
                    var useLang = app_lang;
                } else {
                    var useLang = fallback_lang;
                }
                var initFlatpicker = function () {
                    flatpickr.localize(flatpickr.l10ns[useLang]);
                    var flat_defaults = {
                        time_24hr: true,
                        firstDayOfWeek: 1,
                        // This part is required to make a faltpckr input validatable
                        allowInput:true,
                        onOpen: function(selectedDates, dateStr, instance) {
                            $(instance.altInput).prop('readonly', true);
                        },
                        onClose: function(selectedDates, dateStr, instance) {
                            $(instance.altInput).prop('readonly', false);
                            $(instance.altInput).blur();
                        }
                    };
                    $('.js-flatpickr').each(function(index) {
                        var this_item = $(this);
                        var options = $.extend({}, flat_defaults, this_item.data());

                        if (this_item.data('type') === 'time' || this_item.data('type') === 'datetime-local') {
                            options.enableTime = true;
                        }

                        if (this_item.data('type') === 'time') {
                            options.noCalendar = true;
                        }

                        this_item.flatpickr(options);
                    });
                    initLoadedFloatLabels();
                }
                initFlatpicker();
            }
        );
    }

    return {
        init: function () {
            // lazy load css background images with webp support
            Modernizr.on('webp', function (result) {
                options.webp = result;

                if (!result) {
                    $('.js-lazy-bg').each(function () {
                        var bgElem = $(this);
                        var bgImage = bgElem.data('bg');
                        var bgFallbackExt = bgElem.data('fallback-ext');
                        bgElem.css('background-image', 'url(' + bgImage.replace('.webp', bgFallbackExt) + ')');
                    });

                    $('.js-lazy-bg').waypoint(
                        function () {
                            var bgElem = $(this.element);
                            var bgImage = bgElem.data('bg');
                            var bgFallbackExt = bgElem.data('fallback-ext');
                            bgElem.css('background-image', 'url(' + bgImage.replace('.webp', bgFallbackExt) + ')');

                            this.destroy();
                        }, {
                            offset: '100%',
                        }
                    );
                }
            });

            options.cache['body'] = $('body');
            options.cache['window'] = $(window);
            options.cache['navWrapper'] = $('.js-nav-wrapper');
            options.cache['nav'] = $('.js-nav');
            options.cache['navClose'] = $('.js-nav-close');
            options.cache['filterWrapper'] = $('.js-mobile-filters');
            options.cache['filterWrapperInner'] = $('.js-filter-wrapper');

            options.cache['body'].on('lazyloaded', function(e) {
                if (e.target.classList.contains('js-header-logo-image')) {
                    checkNavLinksOverflow();
                }
            });

            const logoImg = options.cache['body'].find('.js-header-logo-image')[0];
            if (logoImg) {
                if (logoImg.complete) {
                    checkNavLinksOverflow();
                } else {
                    logoImg.addEventListener('load', checkNavLinksOverflow);
                }
            }

            if ($('.js-dropdown-toggle').length) {
                initDropdowns();
            }

            getAndInitMainNav();

            if ($('.cart-widget').length) {
                initCartWidget();
            }

            if (options.view === 'mobile' && $('.js-mobile-filters').length) {
                initFilterOverlay();
            }

            if ($('.js-open-search').length) {
                initSearch();
            }

            if ($('.js-slider').length) {
                initSlider($('.js-slider'));
            }

            if ($('.js-carousel').length) {
                $('.js-carousel').each(function() {
                    initCarousel($(this));
                });
            }

            if ($('.js-products-carousel').length) {
                $('.js-products-carousel').each(function() {
                    productsCarousel($(this));
                });
            }

            initBrands();

            erdsoft.initTimer();

            if ($('.js-product-gallery').length) {
                initProductGallery($('.js-product-gallery'));
            }

            initAccordions();

            initModals();

            initLoadedFloatLabels();

            if ($('.js-poll').length) {
                initPoll();
            }

            $('.js-trigger-filter').on('click', function() {
                var targetBox = $(this).closest('.js-filter-box');
                targetBox.toggleClass('filter--open');
                targetBox.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", handleStickyFilters);
            });

            options.cache['body'].on('click', '.js-show-more-filters', function() {
                $(this).toggleClass('expanded').find('span').toggle();
                var expander = $(this).closest('.js-filter-box').find('.js-expandable');
                expander.toggleClass('filter__options--expanded');
                expander.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", handleStickyFilters);
            });

            //Menu list, show more
            if ($('.js-menu').length > 0) {
                var showMoreMenu = $('.js-show-more-menu');
                var menuList = $('.js-menu');
                var menuBlockLenght = $('.js-menu-block').length;

                if (menuBlockLenght > 4) {
                    showMoreMenu.css("display","inline-block");
                }

                showMoreMenu.on('click', function() {
                    if(menuList.hasClass('opened')) {
                        menuList.removeClass('opened')
                        showMoreMenu.html('Showe more');
                    }else {
                        menuList.addClass('opened')
                        showMoreMenu.html('Showe less');
                    }
                });
            }


            if ($('.plain-text table.js-bt').length > 0) {
                $('.plain-text table.js-bt').basictable({
                    breakpoint: 1024,
                    forceResponsive: false,
                });
            }

            $('.plain-text iframe[src*="//www.youtube.com"]').each(function () {
                var ytFrame = $(this);
                if (ytFrame.parent().hasClass('.plain-text')) {
                    ytFrame.unwrap();
                }

                ytFrame.wrap('<div class="resp-169"></div>');
            });

            $('.js-to-top').on('click', function() {
                $('html, body').animate({ scrollTop: 0 });
            });

            if ($('.js-lightgallery').length > 0) {
                lightGallery(document.querySelector('.js-lightgallery'), {
                    plugins: [lgZoom, lgThumbnail, lgFullscreen, lgAutoplay],
                    licenseKey: lightgallery_key,
                    selector: '.js-lightgallery-item',
                    download: false,
                    hash: false,
                    subHtmlSelectorRelative: true,
                    exThumbImage: 'data-exthumbimage',
                });
            }

            options.cache['window']
                .on('resize', erdsoft.throttle(erdsoft.resizeHandler, 250))
                .trigger('resize');
            options.cache['window']
                .on('scroll', erdsoft.throttle(erdsoft.scrollHandler, 150))
                .trigger('scroll');

            if($('.js-flatpickr').length) {
                initFlatpickr();
            }
        },

        setCache: function (index, value) {
            options.cache[index] = value;
        },

        getCache: function (index) {
            if (typeof options.cache[index] !== 'undefined') {
                return options.cache[index];
            }

            console.warn('Unknown cache index: ' + index);
            return null;
        },

        setOption: function (index, value) {
            options[index] = value;
        },

        getView: function () {
            return options.view;
        },

        getBreakpoint: function () {
            return options.mobileBreakpoint;
        },

        getScrollPosition: function () {
            return options.scrollPosition;
        },

        svgIcon: function (customParams) {
            var defaultParams = {
                name: '',
                title: '',
                file: icons_path,
            };

            var params = $.extend({}, defaultParams, customParams);

            if (params.title !== '') {
                params.title = '<title>' + params.title + '</title>';
            }

            var svgIcon = '<svg class="icon icon--' + params.name + '">';
            svgIcon += params.title + '<use xlink:href="' + params.file + '#' + params.name + '"></use>';
            svgIcon += '</svg>';

            return svgIcon;
        },

        openModal: function (setup) {
            if (options.pluginsLoaded.jconfirm === false) {
                initJconfirm(setup);
                return false;
            }

            var customContentReady = null;
            if (typeof setup.onContentReady == 'function') {
                customContentReady = setup.onContentReady;
                delete setup.onContentReady;
            }

            var defaultSetup = {
                type: 'dialog',
                title: false,
                content: '',
                backgroundDismiss: true,
                typeAnimated: false,
                animationSpeed: 200,
                animateFromElement: false,
                onContentReady: function () {
                    modalLoaded();
                    var currentModalContent = this.$content;

                    var human_id_elem = $('[data-modal-id]', currentModalContent);
                    var modal_id = false;
                    if (human_id_elem.length > 0) {
                        modal_id = human_id_elem.first().data('modal-id');
                    }
                    else {
                        // just generate a random one based on microtime?
                        modal_id = 'modal-' + Date.now();
                    }
                    currentModalContent
                        .attr('data-modal-id', modal_id)
                        .data('modal-id', modal_id);

                    setTimeout(function () {
                        currentModalContent
                            .closest('.jconfirm-box')
                            .addClass('jconfirm-box-scrollable')
                    }, 100);

                    if (typeof setup.sucomModal !== 'undefined') {
                        currentModalContent
                            .closest('.jconfirm-box')
                            .addClass('sucom-modal');
                    }

                    if (typeof customContentReady == 'function') {
                        customContentReady.call(this);
                    }
                },
                buttons: {
                    ok: {
                        text: 'OK',
                    },
                    close: {
                        text: translations.do_cancel,
                    },
                },
                onOpenBefore: function () {
                    $('html').addClass('modal-open');
                    adjustElementsOnModalOpen();
                },
                onDestroy: function () {
                    // first check if we have a modal id
                    var modal_id = this.$content.data('modal-id');
                    if (modal_id) {
                        erdsoft.closeModals(modal_id);
                    }

                    if (options.openedModals.length === 0 || !modal_id) {
                        $('html').removeClass('modal-open');
                        adjustElementsOnModalClose();
                    }
                },
                useBootstrap: false,
                boxWidth: '600px',
            };

            var finalSetup = $.extend({}, defaultSetup, setup);
            var type = finalSetup.type;

            delete finalSetup.type;

            // if (typeof modal !== 'undefined' && setup.content.toLowerCase().indexOf('url:') === 0 ) {
            if (setup.content.toLowerCase().indexOf('url:') === 0 ) {
                this.closeModals();
            }

            var modal = $[type](finalSetup);
            options.openedModals.push(modal);
        },

        closeModals: function (target_modal) {
            var target_modal = target_modal || false;
            // do we have a specific modal to close?
            if (target_modal !== false) {
                for (name in options.openedModals) {
                    // search for it...
                    var this_id = options.openedModals[name].$content.data('modal-id');
                    if (typeof this_id != 'undefined' && this_id == target_modal) {
                        options.openedModals[name].close();
                        options.openedModals.splice(name, 1);
                        break;
                    }
                }
            }
            else {
                for (name in options.openedModals) {
                    options.openedModals[name].close();
                    options.openedModals.splice(name, 1);
                }
            }
        },

        getModals: function (target_modal) {
            var target_modal = target_modal || false;

            if (target_modal !== false) {
                for (name in options.openedModals) {
                    // search for it...
                    var this_id = options.openedModals[name].$content.data('modal-id');
                    if (typeof this_id != 'undefined' && this_id == target_modal) {
                        return options.openedModals[name];
                    }
                }

                return false;
            }
            else {
                return options.openedModals;
            }
        },

        initDiscountCarousel: function(carousel) {
            var carouselEl = carousel[0];

            if (carousel.find('.swiper-slide').length > 1) {
                var carouselWrap = carouselEl.closest('.js-carousel-wrapper');

                var discountCarousel = new Swiper (carouselEl, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    pagination: {
                        el: carouselWrap.querySelector('.js-discount-pagination'),
                        dynamicBullets: true,
                        clickable: true
                    },
                    navigation: false
                });
            }
        },

        initMarketingPopup: function(popupId, content, cookieExpiry = 7, timeout = 3) {
            // early return if content or popupId is not passed
            if (!popupId || !content) {
                return;
            }

            const maxStoredPopups = 100;
            const cookieName = 'popup_closed';
            var popupStatuses = [];

            // retrieve and parse the popup statuses from cookie
            try {
                const cookieValue = Cookies.get(cookieName);
                popupStatuses = cookieValue ? JSON.parse(cookieValue) : [];
                // make sure that popupStatuses is an array
                if (!Array.isArray(popupStatuses)) {
                    popupStatuses = [];
                }
            } catch (e) {
                popupStatuses = [];
            }

            // remove the oldest entry if max size is reached
            if (popupStatuses.length >= maxStoredPopups) {
                popupStatuses.shift();
            }

            // save current popup id on close as done
            popupStatuses.push(popupId);
            popupStatuses = $.unique(popupStatuses.sort()); // $.unique doe not work without sort()

            setTimeout(function() {
                erdsoft.openModal({
                    theme:'popup',
                    type: 'alert',
                    content: content,
                    buttons: false,
                    onClose: function () {
                        // set popup cookie on close
                        Cookies.set(cookieName, JSON.stringify(popupStatuses), { expires: cookieExpiry });
                    },
                });
            }, timeout * 1000);

            $('body').on('click', '.js-popup-click', function (ev) {
                // set popup cookie when we are redirected
                Cookies.set(cookieName, JSON.stringify(popupStatuses), { expires: cookieExpiry });
            })
        },

        resizeHandler: function () {
            options.currentWidth = Math.floor(options.cache['body'].outerWidth());
            options.mobileBreakpoint = options.baseMobileBreakpoint - getScrollBarWidth();
            options.viewport = {
                width: options.cache['window'].innerWidth(),
                height: options.cache['window'].innerHeight(),
            };

            if (options.currentWidth > options.mobileBreakpoint && (options.lastWidth <= options.mobileBreakpoint || options.firstResize === true)) {
                options.view = 'desktop';
                options.firstResize = false;
                options.mobileNavOpen = false;

                options.cache['navWrapper'].removeAttr('style');
                options.cache['nav'].removeAttr('style');

                if(options.cache['filterWrapper']) {
                    options.cache['filterWrapper'].removeClass('filter-is-open');
                    options.cache['body'].removeClass('overflow');
                }

                if( options.cache['search']) {
                    options.cache['search'].removeAttr('style');
                    closeSearch();
                }

                $('.js-subnav').removeAttr('style');

                initDesktopSlidingNav();

                setBottomNav();

                options.cache['body']
                    .removeClass('mobile-view overflow')
                    .addClass('desktop-view');
            }
            else if (options.currentWidth <= options.mobileBreakpoint && (options.lastWidth > options.mobileBreakpoint || options.firstResize === true)) {
                options.view = 'mobile';
                options.firstResize = false;
                options.mobileNavOpen = false;

                initMobileNav();

                $('.js-pager-wrapper').css('margin-right', 0);

                options.cache['body']
                    .removeClass('desktop-view')
                    .addClass('mobile-view');

                if( options.cache['search']) {
                    options.cache['search'].removeAttr('style');
                    closeSearch();
                }
            }

            if (options.currentWidth > options.mobileBreakpoint) {
                checkNavLinksOverflow();
            }

            if (options.currentWidth < 1024) {
                addToCartFixed()
            } else {
                options.cache['body'].find('.site-wrap').css('padding-bottom', '');
            }

            erdsoft.setProductBoxEqualHeights();
            adjustElementsOnModalOpen();
            setSiteWrapperMargin('.site-wrap', '.js-info-bar-top')

            erdsoft.handleStickySidebars();

            options.lastWidth = options.currentWidth;

            handleStickyFilters();

            if ($('.js-bar-marquee')) {
                setMarqueeSpeed();
            }
        },

        scrollHandler: function () {
            if (pageYOffset > 0) {
                if (options.sticky === false) {
                    options.sticky = true;
                    $('.js-header').addClass('header--sticky');
                    options.cache['body'].addClass('sticky');

                    if (options.cache['body'].hasClass('home')) {
                        $('.js-category-nav-parent').removeClass('default-open');
                    }
                }
            }
            else {
                options.sticky = false;
                $('.js-header').removeClass('header--sticky');
                options.cache['body'].removeClass('sticky');

                if (
                    themeSettings.show_categories_by_default
                    && options.cache['body'].hasClass('home')
                    && !$('.js-category-nav-parent').hasClass('js-touched')
                    && $('.js-hero').length
                ) {
                    $('.js-category-nav-parent').addClass('default-open');
                }
            }

            // re-position sticky sidebar if the page scrolls while a modal is open
            if ($('html').hasClass('modal-open') || $('html').hasClass('overflow')) {
                erdsoft.handleStickySidebars();
            }

            handleStickyFilters();
        },

        scrollTo: function (pathname, direct, e) {
            var direct = direct || false;
            var reg = /#/;
            e = e || false;
            if (reg.test(pathname)) {
                pathname = pathname.split('#').pop();
                var to_id = '[data-scroll="' + pathname + '"]';

                if ($(to_id).length > 0) {
                    if (e) {
                        e.preventDefault();
                    }

                    var topY = $(to_id).offset().top - $('.js-header').outerHeight() - 10;

                    var scrollElement =
                        window.document.scrollingElement ||
                        window.document.body ||
                        window.document.documentElement;

                    $(scrollElement).animate({ scrollTop: topY }, 600, 'easeInOutQuad');
                }
            }
        },

        /* glideBullets: function (wrapper, bullets) {
            $(wrapper + ' .glide__slide').each(function (i) {
                $(bullets).append('<button class="glide__bullet" data-glide-dir="=' + i + '"></button>');
            });
        }, */

        getNodes: function (collection) {
            var nodes = [];
            collection.each(function () {
                nodes.push($(this)[0]);
            });

            return nodes;
        },

        initRating: function() {
            if ($('.js-readonly-rating').length > 0) {
                $('.js-readonly-rating').not('.js-inited').each( function() {
                    var ratingElem = $(this);
                    var rating = ratingElem.data('rating');
                    if (typeof rating === 'undefined') {
                        rating = ratingElem.val();
                    }

                    ratingElem.barrating({
                        theme: 'css-stars',
                        readonly: 'readonly',
                        initialRating: rating,
                    }).addClass('js-inited');
                });
            }
        },

        initComments: function() {
            $('.js-comment-item').each(function () {
                var thisComment = $(this);
                if ($('.comments__item-text > div > span', thisComment).innerHeight() > 86) {
                    $('.comments__item-text > div', thisComment).addClass('compressed');
                    $('.js-comment-more', thisComment).show();
                }
            });
        },

        initTooltips: function() {
            $('.js-tooltip').tooltipster({
                maxWidth: 300,
                trigger: ('ontouchstart' in window) ? 'click' : 'hover',
                theme: ['tooltipster-borderless', 'tooltipster-borderless-custom']
            });
        },

        showVoteResults: function(response, form) {
            var poll = $(form);
            var poll_wrapper = poll.closest('.js-poll');
            var results = $('.js-poll-results', poll_wrapper);
            if (response.voted) {
                $('.js-poll-show-form', poll_wrapper).remove();
            }
            if (response.vote_stats) {
                $.each(response.vote_stats, function(index, pollOption) {
                    var voteItem = $('.js-vote-item[data-option-id="' + pollOption.id + '"]');
                    voteItem.find('.js-vote-count').text(pollOption.vote_count);
                    voteItem.find('.js-vote-percentage').css('width', pollOption.vote_percentage + '%');
                });
            }
            results.slideDown();
            poll.slideUp();
        },

        callOnce: function(fn) {
            var called = false;
            return function(...args) {
                if (!called) {
                    called = true;
                    fn.call(this, ...args);
                }
            }
        },

        checkCartResponse: function(form, response) {
            if (response.status == 'fail') {
                var modalOptions = {
                    type: 'alert',
                    title: translations.information,
                    content: response.message,
                    buttons: 'Ok'
                };

                if (response.error_data && response.error_data.type) {
                    modalOptions.buttons = {
                        refresh: {
                            text: translations.refresh,
                            action: function () {
                                // our onClose will take care of this
                            }
                        }
                    };
                    modalOptions.onClose = erdsoft.callOnce(function () {
                        window.location.reload(true);
                    });
                }

                erdsoft.openModal(modalOptions);

                // reset the quantity inputs
                $('.js-number-widget').each(function() {
                    var thisWidget = $(this);
                    var thisQuantityInput = $('.js-number-input', thisWidget);
                    thisQuantityInput.val(thisQuantityInput.prop('defaultValue'));
                });

                return false;
            }
        },

        refreshCartHtml: function(response, form, openWidget) {
            var openWidget = openWidget || false;
            var form = form || false;
            if (response.status == 'success') {
                if (response.trafify && typeof tfyq != 'undefined') {
                    var trafify_data = response.trafify;
                    if (typeof window._trfy == 'object' && typeof window._trfy.getCampaignCookie == 'function') {
                        trafify_data.campaign = window._trfy.getCampaignCookie();
                    }
                    window.tfyq('subtype', 'purchase_item', trafify_data);
                }

                if ('purchase_event_ga4' in response && typeof gtag === "function") {
                    gtag('event', 'purchase', response.purchase_event_ga4)
                }

                if (typeof response.cart_html !== 'undefined' && response.cart_html.length > 0 && $('.js-items-wrapper').length > 0) {
                    if (response.total_quantity <= 0) {
                        window.location.reload(true);
                    }
                    $('.js-items-wrapper').replaceWith(response.cart_html);
                }

                if (response.widget_html.length > 0) {
                    $('.js-cart-widget').replaceWith(response.widget_html);
                    if (openWidget) {
                        $('.js-cart-widget-body').addClass('cart-widget-is-open');
                        moveChatWidget();
                    }
                }

                if (typeof response.overview_html !== 'undefined' && response.overview_html.length > 0) {
                    $('.js-overview').replaceWith(response.overview_html);
                }

                if (typeof response.delivery_html !== 'undefined' && response.delivery_html.length > 0) {
                    $('.js-delivery-options').replaceWith(response.delivery_html);
                }

                if (typeof response.payment_html !== 'undefined' && response.payment_html.length > 0 && $('.js-cart-section').length > 0) {
                    if (response.page_title && $('.js-page-title').length > 0) {
                        $('.js-page-title').text(response.page_title);
                    }
                    $('.js-cart-section').replaceWith(response.payment_html);
                    $('html, body').animate({ scrollTop: 0 });
                }

                var stepper = $('.js-form-wizard');
                if (stepper.length > 0 && typeof replaceSidebar == 'function') {
                    var currentIndex = stepper.steps('getCurrentIndex');
                    replaceSidebar(currentIndex);
                }

                if (form && $(form).data('closeModals')) {
                    erdsoft.closeModals();
                }
            }
        },

        refreshPreorder: function(response, form) {
            if (response.status == 'success') {
                erdsoft.closeModals();
            }
        },

        refreshBooking: function (response, form) {
            if (response.status == 'success') {
                erdsoft.closeModals();
            }
        },

        getFloatLabelInstance: function() {
            return erdsoft.floatLabelInstance;
        },

        gdprAccepted: function(response, form) {
            $('.js-cookies-overlay').fadeOut(300);
            $('.js-cookies').fadeOut(300);
            $('.js-toggle-cookie-panel').removeClass('cookies__show-panel--hidden');
            var cookieRejectButton = $('.js-cookie-reject');
            var cookieAcceptAllButton = $('.js-cookie-all');

            cookieRejectButton.prop('disabled', false).removeClass('button--loading');
            cookieAcceptAllButton.prop('disabled', false).removeClass('button--loading');

            erdsoft.closeCookieDetails();
            if (window.google_tag_manager) {
                erdsoft.setCookieConsent(response.allowed_cookies);
            }
        },

        closeCookieDetails: function() {
            var toggleButton = $('.js-toggle-cookie-details');
            var toggleButtonText = toggleButton.find('.js-cookies-details-text');
            var cookieDetails = $('.js-cookie-details');
            if (toggleButton.hasClass('cookies__button--rotate-icon js-toggle-cookie-details-active')) {
                toggleButton.removeClass('cookies__button--rotate-icon js-toggle-cookie-details-active');
                toggleButtonText.text(toggleButton.find('.js-cookies-details-text').data('show-text'));
                cookieDetails.slideUp(300, 'easeInOutQuad');
            }
        },

        setCookieConsent: function(consent) {
            const consentMode = {
                'ad_storage': consent.includes('marketing') ? 'granted' : 'denied',
                'ad_user_data': consent.includes('marketing') ? 'granted' : 'denied',
                'ad_personalization': consent.includes('marketing') ? 'granted' : 'denied',
                'analytics_storage': consent.includes('statistics') ? 'granted' : 'denied',
                'functionality_storage': consent.includes('necessary') ? 'granted' : 'denied',
                'personalization_storage': consent.includes('preferences') ? 'granted' : 'denied',
                'security_storage': consent.includes('necessary') ? 'granted' : 'denied',
                'wait_for_update': 500
            };
            gtag('consent', 'update', consentMode);
            localStorage.setItem('consentMode', JSON.stringify(consentMode));
        },

        addSelect2Template: function (name, callback) {
            select2Templates[name] = callback;
        },

        initSelectTwos: function(selector) {
            var select2_defaults = {
                language: app_lang,
                // minimumResultsForSearch: Infinity
            };
            selector = selector || '.js-select';
            $(selector).not('.js-inited, .js-init-later').each(function() {
                var select = $(this);
                var data_options = select.data();
                var textIndex = data_options.textIndex || false;
                if (data_options.tags) {
                    data_options.tags = true;
                    data_options.createTag = function (params) {
                        var term = $.trim(params.term);
                        if (term === '') {
                            return null;
                        }
                        return {
                            id: term,
                            text: term,
                            newTag: true,
                        }
                    };
                }
                if (data_options.templateResult && select2Templates[data_options.templateResult]) {
                    data_options.templateResult = select2Templates[data_options.templateResult];
                }
                if (data_options.templateSelection && select2Templates[data_options.templateSelection]) {
                    data_options.templateSelection = select2Templates[data_options.templateSelection];
                }

                if (data_options.dropdownAdapter) {
                    data_options.dropdownAdapter = $.fn.select2.amd.require(data_options.dropdownAdapter);

                    // this is to trigger an automatic search when we select something from the simple suggestion list
                    $('body').on('click', '.js-simple-suggest', function (ev) {
                        var searchInput = select.data('select2').dropdown.$search || select.data('select2').selection.$search;

                        // This is undocumented and may change in the future
                        searchInput.val($(this).text());
                        searchInput.trigger('input');
                    });

                    if (select.hasClass('js-search-select')) {
                        data_options.dropdownParent = $('.js-search');
                    }
                }

                if (typeof data_options.dropdownParent == 'string') {
                    data_options.dropdownParent = $(data_options.dropdownParent);
                }

                // is it an ajax thing?
                if (data_options.url) {
                    data_options.ajax = {
                        url: data_options.url,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            var data = {
                                query: params.term, // search term
                                page: params.page
                            };

                            var current_select = this;
                            var this_form = current_select.closest('form');
                            var extra_data_selector = current_select.data('extraDataSelector')
                            var extra_inputs = $('input.js-extra-data, textarea.js-extra-data, select.js-extra-data' + (extra_data_selector ? ', ' + extra_data_selector : ''), this_form);
                            if (extra_inputs.length > 0) {
                                var extra_data = extra_inputs.serializeArray();
                                $.each( extra_data, function( extra_key, extra_value ) {
                                    if (extra_value.name != current_select.prop('name')) {
                                        data[extra_value.name] = extra_value.value;
                                    }
                                });
                            }

                            if (data_options.dropdownAdapter) {
                                data.header_search = true;
                            }
                            return data;
                        },
                        processResults: function (results, params) {
                            // parse the results into the format expected by Select2
                            // since we are using custom formatting functions we do not need to
                            // alter the remote JSON data, except to indicate that infinite
                            // scrolling can be used
                            params.page = params.page || 1;

                            results.data = $.map(results.data, function (obj) {
                                obj.text = obj[textIndex] || obj.text || obj.name || obj.title; // replace name with the property used for the text
                                return obj;
                            });

                            // we only need this with out custom adapter
                            if (data_options.dropdownAdapter) {
                                var searchSuggestionsDiv = $('.js-search-suggestions');
                                var categorySuggestionsDiv = $('.js-category-suggestions');
                                var brandSuggestionsDiv = $('.js-brand-suggestions');
                                var emptyResultSetDiv = $('.js-empty-resultset');
                                var allResultsDiv = $('.js-select2-view-all');

                                if (params.page && params.page === 1) {
                                    allResultsDiv.html('');
                                    if (params.term && params._type == 'query') {
                                        allResultsDiv.html('<a href="' + results.path + '?query=' + params.term + '">' + translations.view_all + '</a>');

                                        $(document).on('keyup', '.select2-search__field', function(e) {
                                            var keycode = (e.keyCode ? e.keyCode : e.which);

                                            if (keycode === 13) {
                                                var redirect = results.path + '?query=' + params.term;

                                                select.select2('close');

                                                $('.overlay').fadeOut(300, function() {
                                                    $('html.overflow, body.overflow').removeClass('overflow');
                                                });

                                                window.location = redirect;
                                            }
                                        });
                                    }
                                }

                                searchSuggestionsDiv.html('');
                                if (results.suggestions && results.suggestions.searches) {
                                    $.each(results.suggestions.searches, function (key, value) {
                                        searchSuggestionsDiv.append('<li>' + erdsoft.svgIcon({name: 'search'}) + '<a href="javascript:void(0);" class="js-simple-suggest">' + value.term + '</a></li>');
                                    });
                                }

                                categorySuggestionsDiv.html('');
                                if (results.categories && results.categories.length > 0) {
                                    $.each(results.categories, function (key, value) {
                                        categorySuggestionsDiv.append('<li><a href="' + value.pretty_url + '">' + value.name + '</a></li>');
                                    });
                                    categorySuggestionsDiv.closest('.js-category-suggestions-wrapper').show();
                                } else {
                                    categorySuggestionsDiv.closest('.js-category-suggestions-wrapper').hide();
                                }

                                brandSuggestionsDiv.html('');
                                if (results.brands && results.brands.length > 0) {
                                    $.each(results.brands, function (key, value) {
                                        brandSuggestionsDiv.append('<li><a href="' + value.pretty_url + '">' + value.name + '</a></li>');
                                    });
                                    brandSuggestionsDiv.closest('.js-brand-suggestions-wrapper').show();
                                } else {
                                    brandSuggestionsDiv.closest('.js-brand-suggestions-wrapper').hide();
                                }

                                $('.js-select2-totals').text(results.total + ' ' + translations.results);

                                // if we have no matches, but we have some suggestions, make the user aware of the top suggestion
                                emptyResultSetDiv.html('');
                                if (
                                    results.total <= 0
                                    && results.suggestions && results.suggestions.searches && results.suggestions.searches[0]
                                ) {
                                    emptyResultSetDiv.html(translations.did_you_mean + ' <a href="javascript:void(0);" class="js-simple-suggest"><strong>' + results.suggestions.searches[0].term + '</strong></a>?');
                                }
                            }

                            return {
                                results: results.data,
                                pagination: {
                                    more: (params.page * results.per_page) < results.total
                                }
                            };
                        },
                        cache: true
                    };
                }

                var select2Options = $.extend({}, select2_defaults, data_options);
                select.select2(select2Options).addClass('js-inited');
                if (data_options.redirect) {
                    select.on('select2:select', function (e) {
                        var selected_data = e.params.data;
                        var redirect = selected_data[data_options.redirect];

                        $(this).select2('close');

                        $('.overlay').fadeOut(300, function() {
                            $('html.overflow, body.overflow').removeClass('overflow');
                        });

                        if (redirect) {
                            window.location = redirect;
                        }
                    });

                    if (data_options.dropdownAdapter) {
                        select.on('select2:closing', function (e) {
                            $('.js-select2-view-all').html('');
                            $('.js-select2-totals').text('');
                        });
                    }
                }

                if (data_options.dropdownAdapter) {
                    $(document).on('keydown', '.select2-search__field', function(e) {
                        if (e.which == 9) {
                            e.preventDefault();
                            select.select2('open');
                        }
                    });
                }

                // Handle select2 floating labels
                if (themeSettings.float_contact_form_labels) {
                    select.on('select2:select', function() {
                        $(this).closest('.fl-wrap').addClass('fl-is-active');
                    });

                    select.on('change', function() {
                        if ($(this).val() === null || $(this).val().length === 0) {
                            $(this).closest('.fl-wrap').removeClass('fl-is-active');
                        }
                    });
                }
            });
        },

        initTimer: function() {
            $('.js-product-timer').not('.is-countdown').each(function() {
                var $this = $(this),
                    expires = $this.data('expires'),
                    color = $this.data('color'),
                    format_in = $this.data('format') || 'dHMS',
                    date = expires.split(' ')[0],
                    time = expires.split(' ')[1],
                    year = parseInt(date.split('-')[0],10),
                    month = parseInt(date.split('-')[1],10) - 1,
                    day = parseInt(date.split('-')[2],10),
                    hours = parseInt(time.split(':')[0],10),
                    minutes = parseInt(time.split(':')[1],10),
                    seconds = parseInt(time.split(':')[2],10);

                $this.countdown({
                    until: new Date(year, month, day, hours, minutes, seconds),
                    format: 'dHMS',
                    layout: '<span class="countdown-row countdown-show4">{d<}<span class="countdown-section countdown-section--days"><span class="countdown-amount">{dn}</span> <span class="countdown-label">' + translations.day + '</span></span>{d>}<span class="countdown-section"><span class="countdown-amount">{hnn}</span><span class="countdown-label">' + translations.hours + '</span></span><span class="countdown-section"><span class="countdown-amount">{mnn}</span><span class="countdown-label">' + translations.minutes + '</span></span><span class="countdown-section"><span class="countdown-amount">{snn}</span><span class="countdown-label">' + translations.seconds + '</span></span></span>'
                });
            });
        },

        handleStickySidebars: function() {
            if (options.stickyElements.length && options.currentWidth > 1023) {
                var offset = 0;
                if ($('html').hasClass('modal-open') || $('html').hasClass('overflow')) {
                    offset = $(window).scrollTop();
                }
                erdsoft.setStickyElements(offset);
            } else {
                $('.js-sticky-sidebar').css('top', '');
            }
        },

        setStickyElements: function(offset = 0) {
            $.each(options.stickyElements, function (index, className) {
                $(className).each(function() {
                    var $element = $(this);
                    var initialTop = erdsoft.getInitialTopValue($element) + offset;
                    erdsoft.setTopValue($element, initialTop);
                });
            });
        },

        getInitialTopValue: function(el) {
            el.css('top', '');
            var initialTop = parseFloat(el.css('top')); // Get initial 'top' using css()
            return initialTop;
        },

        setTopValue: function(element, initialTop) {
            var newTopValue = initialTop + options.siteWrapperMargin; // Add the site wrappers margin

            if (parseFloat(element.css('top')) == newTopValue) {
                return
            }

            element.css('top', newTopValue + 'px'); // Set the new top value
        },

        initValidation: function() {
            if ($().validate) {
                // just some more complicated validation we need to use in 1 place (i know)
                $.validator.addMethod("condcheck", function(value, element) {
                    var this_form = $(element).closest('form');
                    var same_thing = $('.js-same-address', this_form);
                    if (same_thing.is(':checked')) {
                        return true;
                    }
                    else {
                        var type_check = $("input[name='address[payment][address_type]'][value='1']:checked");
                        if (type_check.length > 0) {
                            return value.length > 0;
                        }
                        else {
                            return true;
                        }
                    }
                }, $.validator.format(translations.rule_required));

                $.validator.addMethod("pattern", function(value, element, param) {
                    if (this.optional(element)) {
                        return true;
                    }
                    if (typeof param === "string") {
                        param = new RegExp("^(?:" + param + ")$");
                    }
                    return param.test(value);
                }, translations.invalid_format);

                // Initialize
                $('.js-form-validate-jquery').not('.inited').each(function () {
                    $(this).validate({
                        ignore: 'input[type=hidden], .select2-search__field, .dont-validate', // ignore hidden fields
                        errorClass: 'form__control--error',
                        focusInvalid: false,
                        normalizer: function (value) {
                            var elem = $(this);
                            var elem_id = elem.attr('id');
                            if (elem.hasClass('js-ck-text') && CKEDITOR && CKEDITOR.instances[elem_id]) {
                                CKEDITOR.instances[elem_id].updateElement();
                                value = CKEDITOR.instances[elem_id].getData();
                            } else if (elem.data('fieldNormalizer')) {
                                var normalizerCall = elem.data('fieldNormalizer');
                                if (normalizerCall && typeof window[normalizerCall] == 'function') {
                                    value = window[normalizerCall](value, elem);
                                }
                            }
                            return $.trim(value);
                        },
                        invalidHandler: function (form, validator) {
                            if (!validator.numberOfInvalids()) {
                                return;
                            }

                            var to_elem = $(validator.errorList[0].element).closest('.form__item');
                            if (to_elem.length > 0) {
                                var topY = to_elem.offset().top - $('.js-header').outerHeight() - 10;

                                var scrollElement =
                                    window.document.scrollingElement ||
                                    window.document.body ||
                                    window.document.documentElement;

                                if (to_elem.closest('.jconfirm-box').length) {
                                    if (options.view === 'mobile') {
                                        topY = to_elem.offset().top - to_elem.closest('.jconfirm-row').offset().top;
                                        scrollElement = to_elem.closest('.jconfirm-scrollpane');
                                    } else {
                                        topY = to_elem.offset().top - to_elem.closest('.jconfirm-content-pane').offset().top;
                                        scrollElement = to_elem.closest('.jconfirm-box');
                                    }
                                }

                                $(scrollElement).animate({ scrollTop: topY }, 600, 'easeInOutQuad');
                            }
                        },
                        highlight: function (element, errorClass, validClass) {
                            $(element).addClass(errorClass);
                        },
                        unhighlight: function (element, errorClass, validClass) {
                            $(element).removeClass(errorClass);
                        },
                        // Different components require proper error label placement
                        errorPlacement: function (error, element) {
                            if (element.data('fieldErrorPlacement')) {
                                var placementCall = element.data('fieldErrorPlacement');
                                if (placementCall && typeof window[placementCall] == 'function') {
                                    window[placementCall](error, element);
                                }
                            } else {
                                if (element.attr('type') == 'checkbox') {
                                    error.insertAfter(element.closest('.form__cb-label')).addClass('validation-invalid-label');
                                } else {
                                    var formItem = element.closest('.form__item');
                                    if (formItem.length) {
                                        if (formItem.find('.form-text').length) {
                                            formItem.find('.form-text').wrap('<div class="error-wrapper"></div>');
                                            error.appendTo(formItem.find('.error-wrapper')).addClass('validation-invalid-label');
                                        } else {
                                            error.appendTo(formItem).addClass('validation-invalid-label');
                                        }
                                    } else {
                                        error.insertBefore(element).addClass('validation-invalid-label');
                                    }
                                }
                            }
                        },
                        submitHandler: function (form) {
                            // do we have a file uploading?
                            var currently_uploading = $('.file-input.is-locked', $(form));
                            if (currently_uploading.length > 0) {
                                // show a warning
                            }
                            else {
                                var this_button = $('button[type="submit"]', $(form));
                                var ajaxOptions = {
                                    type: $(form).prop('method'),
                                    url: $(form).prop('action'),
                                    dataType: 'json',
                                    data: $(form).serializeArray(),
                                    beforeSend: function (jqXHR) {
                                        this_button.addClass('disabled button--loading').attr('disabled', 'disabled').prop('disabled', true);
                                    },
                                    complete: function (jqXHR, textStatus) {
                                        this_button.removeClass('disabled button--loading').removeAttr('disabled').prop('disabled', false);
                                    },
                                    success: function (response) {
                                        var silent_call = $(form).data('silent');
                                        var response_msg = response.message;

                                        var doContinue = true;
                                        var onComplete = $(form).data('onComplete');
                                        if (typeof window[onComplete] == 'function') {
                                            doContinue = window[onComplete].call(this, form, response);
                                        }
                                        if (typeof erdsoft[onComplete] == 'function') {
                                            doContinue = erdsoft[onComplete].call(this, form, response);
                                        }

                                        if (doContinue === false) {
                                            return;
                                        }

                                        if (response.errors) {
                                            response_msg += '<ul>';
                                            $.each(response.errors, function (key, value) {
                                                response_msg += '<li>' + ($.isArray(value) ? value.join('</li><li>') : value) + '</li>';
                                            });
                                            response_msg += '</ul>';
                                        } else if (response.status == 'success') {
                                            // Users to Trafify
                                            if (response.trafify && typeof tfyq != 'undefined') {
                                                window.tfyq('subtype', response.trafify.method, response.trafify.data);
                                            }
                                            // Subscription to Trafify
                                            if (response.trafify_subscription && typeof tfyq != 'undefined') {
                                                window.tfyq('subtype', response.trafify_subscription.method, response.trafify_subscription.data);
                                            }

                                            if (!$(form).data('noReset')) {
                                                form.reset();
                                            }
                                            var success_call = $(form).data('onSuccess');
                                            if (success_call && typeof window[success_call] == 'function') {
                                                window[success_call](response, form);
                                            }
                                            else if (success_call && typeof erdsoft[success_call] == 'function') {
                                                erdsoft[success_call](response, form);
                                            }
                                        }
                                        if (!silent_call) {
                                            erdsoft.openModal({
                                                type: 'alert',
                                                title: response.title || false,
                                                content: response_msg,
                                                buttons: 'Ok'
                                            });

                                            if (response.redirect_url && response.redirect_url.length > 0) {
                                                setTimeout(function () {
                                                    window.location = response.redirect_url;
                                                }, 1000);
                                            } else if (response.payment_form && response.payment_form.length > 0) {
                                                $('.js-payment-form-wrapper').append(response.payment_form);
                                                setTimeout(function() {
                                                    var paymentForm = $('.js-payment-form-wrapper').find('form');
                                                    if (paymentForm.length > 0) {
                                                        paymentForm.submit();
                                                    }
                                                }, 1000);
                                            }
                                        }
                                    },
                                    error: function (jqXHR, textStatus, errorThrown) {
                                        // we can do some customization like this.
                                        // see resources\views\cart\index.blade.php for an example
                                        var doContinue = true;
                                        var onAjaxError = $(form).data('onAjaxError');
                                        if (typeof window[onAjaxError] == 'function') {
                                            doContinue = window[onAjaxError].call(this, form, jqXHR, textStatus, errorThrown);
                                        }
                                        if (typeof erdsoft[onAjaxError] == 'function') {
                                            doContinue = erdsoft[onAjaxError].call(this, form, jqXHR, textStatus, errorThrown);
                                        }

                                        if (doContinue === false) {
                                            return;
                                        }

                                        $.ajaxSettings.error.call(this, jqXHR, textStatus, errorThrown);
                                    }
                                };

                                if ($(form).data('fileupload') === true) {
                                    $.extend(ajaxOptions, {
                                        data: new FormData(form),
                                        processData: false, // Prevent jQuery from transforming the data
                                        contentType: false, // Allow multipart/form-data
                                    });
                                }

                                $.ajax(ajaxOptions);
                            }
                        },
                    });
                    $(this).addClass('inited');
                });
            }
        },

        layoutMasonry: function() {
            // Check if the Masonry plugin function is defined
            if (typeof $.fn.masonry !== 'function') {
                return;
            }

            var $masonryElement = $('.js-masonry');

            if (!$masonryElement.hasClass('inited')) {
                return;
            }

            // Perform the Masonry layout operation
            $masonryElement.masonry('layout');
        },

        throttle: function(fn, threshhold, scope) {
            threshhold || (threshhold = 250);
            var last, deferTimer;
            return function () {
                var context = scope || this;

                var now = new Date().getTime(),
                    args = arguments;
                if (last && now < last + threshhold) {
                    // hold on to it
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function () {
                        last = now;
                        fn.apply(context, args);
                    }, threshhold + last - now);
                }
                else {
                    last = now;
                    fn.apply(context, args);
                }
            };
        },

        uniqueID: function () {
            // Math.random should be unique because of its seeding algorithm.
            // Convert it to base 36 (numbers + letters), and grab the first 9 characters
            // after the decimal.
            return ('_' + Math.random() .toString(36) .substr(2, 9));
        },

        callScripts: function () {
            if (typeof globalScript === 'function') {
                globalScript();
            }

            if (typeof pageScript === 'function') {
                pageScript();
            }

            if (typeof debugScript === 'function') {
                debugScript();
            }
        },

        initThemePreviewWidget: function () {
            $('.js-theme-widget-tooltip').tooltipster({
                maxWidth: 180,
                trigger: ('ontouchstart' in window) ? 'click' : 'hover',
                theme: ['tooltipster-borderless', 'tooltipster-borderless-custom']
            });

            $('body').on('click', '.js-close-theme-widget', function(ev) {
                ev.preventDefault();

                Cookies.remove('preview_theme');
                Cookies.remove('preview_color');

                window.location.reload(true);
            });

            $('body').on('click', '.js-toggle-theme-selector', function() {
                var themeWidget = $(this).closest('.js-theme-widget');
                themeWidget.toggleClass('theme-widget--expanded');

                if (themeWidget.hasClass('theme-widget--expanded')) {
                    var selectedThemeScreenshot = document.querySelector('.js-theme-selected');
                    selectedThemeScreenshot.scrollIntoView();
                }
            });
        },

        initBookingControls: function () {
            var bookingNavigation = ['.js-booking-today', '.js-booking-previous', '.js-booking-next'];

            bookingNavigation.forEach(function (item) {
                $(item).not('.js-inited').each(function() {
                    var $this = $(this);

                    $this.on('click', function (e) {
                        e.preventDefault();
                        var slotsArguments = [ $('.js-booking-slots-container').data('url') ];

                        if (item === '.js-booking-previous') {
                            slotsArguments.push($('.js-booking-slots-container').data('startOfWeek'));
                            slotsArguments.push('previous');
                        }

                        if (item === '.js-booking-next') {
                            slotsArguments.push($('.js-booking-slots-container').data('startOfWeek'));
                            slotsArguments.push('next');
                        }

                        getReservationSlots(...slotsArguments);
                    });

                    $this.addClass('js-inited');
                });
            });
        },

        setProductBoxEqualHeights: function () {
            if ($('.js-product-parameters').length) {
                setEqualHeights($('.js-product-parameters'));
                setEqualHeights($('.js-product-box'));
            }
        }
    };
})();

$( function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        beforeSend: function () {
            // Handle the beforeSend event
            if (typeof CKEDITOR != 'undefined' && CKEDITOR.instances) {
                $.each(CKEDITOR.instances, function (field_name, ck_data) {
                    ck_data.updateElement();
                });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // no error should be thrown if the request is aborted
            if (textStatus == 'abort') {
                return;
            }
            var response_msg = translations.error_occurred;

            var modalSettings = {
                type: 'alert',
                content: response_msg,
                buttons: 'Ok'
            };

            if (jqXHR.responseJSON) {
                if (jqXHR.responseJSON.errors) {
                    if (jqXHR.status == 422) {
                        response_msg = '';
                    } else {
                        response_msg = jqXHR.responseJSON.message;
                    }

                    response_msg += '<ul>';
                    $.each(jqXHR.responseJSON.errors, function (key, value) {
                        response_msg += '<li>' + value.join('</li><li>') + '</li>';
                    });
                    response_msg += '</ul>';

                    modalSettings.title = translations.information;
                    modalSettings.content = response_msg;
                }

                if (jqXHR.responseJSON.close_modals) {
                    erdsoft.closeModals();
                }

                if (jqXHR.responseJSON.redirect_url) {
                    setTimeout(function () {
                        window.location = jqXHR.responseJSON.redirect_url;
                    }, 1000);
                }
            }

            erdsoft.openModal(modalSettings);
        }
    });

    // Prevent executing the error callback for abort
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (typeof originalOptions.error == 'function') {
            options.error = function (jqXHR, textStatus, errorThrown) {
                if (textStatus != 'abort') {
                    originalOptions.error.call(this, jqXHR, textStatus, errorThrown);
                }
            }
        }
    });

    $.xhrPool = [];
    $(document).ajaxSend(function (event, jqXHR, options) {
        $.xhrPool.push(jqXHR);
    });
    $(document).ajaxComplete(function (event, jqXHR, options) {
        $.xhrPool = $.xhrPool.filter(function (thisXHR) {
            return thisXHR != jqXHR;
        });
    });
    $(window).on('beforeunload', function () {
        $.each($.xhrPool, function (xhrIndex, jqXHR) {
            jqXHR.abort();
        });
    });

    erdsoft.init();
    erdsoft.initDiscountCarousel($('.js-discount-carousel'));

    $('body').on('click', '.js-scroll-to', function (e) {
        var pathname = $(this).attr('href');
        erdsoft.scrollTo(pathname, false, e);
    });

    $('body').on('click', '.js-close-all-modals', function (e) {
        e.preventDefault();
        erdsoft.closeModals();
    });

    $('.js-trigger-filter').find('.js-filter-icon').append(erdsoft.svgIcon({name: themeSettings.filter_arrow}));

    $(window).on('load', function() {
        setTimeout(function () {
            erdsoft.scrollTo(location.hash);
        }, 200);
    });

    if ($('.js-select-comment-tab').length > 0) {
        $('.js-select-comment-tab').on('click', function() {
            $('.js-tab-link[data-tabhref="#comments"]').trigger('click');
        });
    }

    $('.js-category-subnav').closest('li').addClass('category-nav__parent js-category-parent');
    var svgCaretDown = { name: 'caret-down' };
    $('.js-category-parent > a').append('<span class="category-nav__toggle-subnav js-toggle-category-subnav">' + erdsoft.svgIcon(svgCaretDown) + '</span>');
    // $('.js-category-selected').parents('li').addClass('category-nav__item--open').find('> .js-category-subnav').addClass('js-category-opened');
    $('.js-category-selected').parents('li').addClass('category-nav__item--open');

    // $('.js-category-parent').on('click', function(e) {
    $('.js-toggle-category-subnav').on('click', function(e) {
        e.preventDefault();

        var everySubnav = $('.js-category-parent .js-category-subnav');
        var thisSubnav = $(this).closest('li').find('> .js-category-subnav');
        var thisOpened = thisSubnav.hasClass('js-category-opened');

        everySubnav.removeClass('js-category-opened').velocity('stop').velocity('slideUp', { duration: 300, complete: function() {
            everySubnav.removeAttr('style');

            if (!thisOpened) {
                thisSubnav.addClass('js-category-opened').velocity('stop').velocity('slideDown', { duration: 300 });
            }
        }});
    });

    $('.js-category-item').not('.js-category-parent').on('click', function(e) {
        e.stopPropagation();
    });

    if ($('.js-tabs').length > 0) {
        var tabAnchor, currentTab;

        $('.js-tab-link').on('click', function(e) {
            e.preventDefault();

            var tab = $(this);
            var context = tab.closest('.js-tabs');
            var selectedClass = context.data('tab-selected-class') || 'tabs__link--selected';

            tabAnchor = tab.data('tabhref');

            currentTab = $('.js-tabs-content ' + tabAnchor, context);
            if (currentTab.length === 1) {
                $('.js-tab-link', context).removeClass(selectedClass);
                currentTab.siblings().hide();
                currentTab.fadeIn(300).trigger('tabActivated');
                tab.addClass(selectedClass);
            }
        });

        $('.js-tabs').each(function() {
            if (!$(this).find('.js-selected-tab').length) {
                $(this).find('.js-tab-link').eq(0).addClass('js-selected-tab');
            }
        });
        $('.js-selected-tab').trigger('click');
    }

    $('body').on('click', '.js-comment-more', function () {
        var moreButton = $(this);
        var commentItem = moreButton.closest('.js-comment-item');

        commentItem.toggleClass('js-comment-item-opened');

        if (commentItem.hasClass('js-comment-item-opened')) {
            $('.comments__item-text > div', commentItem).removeClass('compressed');
            moreButton.text(moreButton.data('less-text'));
        }
        else {
            $('.comments__item-text > div', commentItem).addClass('compressed');
            moreButton.text(moreButton.data('more-text'));
        }
    });

    $('body').on('keyup', '.js-comment-character-counter', function () {
        var characterCounter = $(this);
        var characters = characterCounter.val().length;
        if (characters > 1000) {
            characterCounter.val(characterCounter.val().substring(0, 1000));
        }
        else {
            $('.js-comment-characters-remaining').text(1000 - characters);
        }
    });

    /**
     * Converts a long string of bytes into a readable format e.g KB, MB, GB, TB, YB
     *
     * @param {Int} num The number of bytes.
     */
    function readableBytes(bytes) {
        var i = Math.floor(Math.log(bytes) / Math.log(1024)),
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
    }

    var file_uploads = $('.js-upload-file');
    if (file_uploads.length > 0) {
        file_uploads.each(function (index) {
            var this_input = $(this);
            var this_form = this_input.closest('form');
            var this_name = this_input.prop('name');
            var this_multiple = this_input.prop('multiple') ? true : false;
            var error_holder = this_input.closest('.js-upload-message');
            var max_files = this_input.data('maxFiles');
            var max_total_size = this_input.data('maxTotalSize');

            var dm_options = {
                // url: route('file_upload').url(),
                fieldName: this_name,
                multiple: this_multiple,
                // maxFileSize: 2000000, // 2 Megs max
                extraData: function () {
                    var form_data = this_input.closest('form').serializeArray();
                    var extra_data = {};
                    extra_data['input_name'] = this_input.prop('name');
                    $.each(form_data, function () {
                        extra_data[this.name] = this.value;
                    });
                    return extra_data;
                },
                onFileSizeError: function (file) {
                    var max_size = this_input.data('maxFileSize');
                    erdsoft.openModal({
                        type: 'alert',
                        content: translations.upload_max_size.replace(':filesize', readableBytes(max_size)),
                        buttons: 'Ok'
                    });
                },
                onFileExtError: function (file) {
                    var allowed = this_input.data('extFilter');
                    erdsoft.openModal({
                        type: 'alert',
                        content: translations.upload_allowed_extensions.replace(':extensions', allowed.join(', ')),
                        buttons: 'Ok'
                    });
                },
                onFileTypeError: function (file) {
                    var allowed = this_input.data('allowedTypes');
                    var allowed_message = this_input.data('allowedTypesMessage') ? this_input.data('allowedTypesMessage') : translations.upload_allowed_filetypes.replace(':filetypes', allowed);
                    erdsoft.openModal({
                        type: 'alert',
                        content: allowed_message,
                        buttons: 'Ok'
                    });
                },
                onNewFile: function (id, file) {
                    var uploader_data = this_input.dmUploader().data();
                    var opened_modals = erdsoft.getModals();
                    if (typeof max_files != 'undefined') {
                        if ((uploader_data.dmUploader.queue.length + 1) > max_files) {
                            if (opened_modals <= 0) {
                                erdsoft.openModal({
                                    type: 'alert',
                                    content: translations.upload_max_count.replace(':maxcount', max_files),
                                    buttons: 'Ok'
                                });
                            }
                            return false;
                        }
                    }

                    if (typeof max_total_size != 'undefined') {
                        var total_size = file.size;
                        $.each(uploader_data.dmUploader.queue, function (key, this_file) {
                            total_size += ~~parseInt(this_file.data.size);
                        });
                        if (total_size > ~~parseInt(max_total_size)) {
                            if (opened_modals <= 0) {
                                erdsoft.openModal({
                                    type: 'alert',
                                    content: translations.upload_max_total.replace(':filesize', readableBytes(max_total_size)),
                                    buttons: 'Ok'
                                });
                            }
                            return false;
                        }
                    }
                },
                onUploadSuccess: function (id, data) {
                    // A file was successfully uploaded
                    if (data.initialPreviewConfig) {
                        $.each(data.initialPreviewConfig, function (key, this_file) {
                            $('.js-uploaded-files', this_form).append('<li data-size="' + this_file.size + '">' + this_file.caption + ' [<button type="button" class="js-remove-uploaded-file" data-url="' + this_file.url + '" data-key="' + this_file.key + '" data-file-id="' + id + '">' + translations.do_remove + '</button>]<input name="' + this_name + '" type="hidden" value="' + this_file.key + '" /></li>');
                        });
                    }
                },
                onComplete: function () {
                    // all files in the queue are processed (success or error)
                    var uploader_data = this_input.dmUploader().data();
                    $.each(uploader_data.dmUploader.queue, function (key, this_file) {
                        if (this_file.status <= 0) {
                            // manually start the upload if we need to
                            this_input.dmUploader('start', this_file.id);
                        }
                    });
                },
            }

            var options = $.extend({}, dm_options, this_input.data());
            this_input.dmUploader(options);
        });
    }

    $('.js-uploaded-files').on('click', '.js-remove-uploaded-file', function (e) {
        e.preventDefault();
        var this_button = $(this);
        var this_form = this_button.closest('form');
        var fileholder = this_button.closest('.js-uploaded-files');
        var uploader = $(fileholder.data('forUploader'), this_form);
        var this_url = this_button.data('url');
        var this_key = this_button.data('key');
        var this_file_id = this_button.data('fileId');

        erdsoft.openModal({
            type: 'confirm',
            // title: 'Alert!',
            content: translations.upload_delete_confirm,
            buttons: {
                ok: {
                    text: 'OK',
                    action: function (heyThereButton) {
                        $.ajax({
                            type: 'POST',
                            url: this_url,
                            dataType: 'json',
                            data: { key: this_key },
                            success: function (response) {
                                this_button.closest('li').remove();
                                var uploader_data = uploader.dmUploader().data();
                                var remove_id = false;
                                $.each(uploader_data.dmUploader.queue, function (key, this_file) {
                                    if (this_file.id == this_file_id) {
                                        remove_id = key;
                                    }
                                });
                                uploader.dmUploader('cancel', this_file_id);
                                // remove the file from the queue
                                uploader_data.dmUploader.queue.splice(remove_id, 1);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                erdsoft.openModal({
                                    type: 'alert',
                                    content: translations.error_occurred,
                                    buttons: 'Ok'
                                });
                            }
                        });
                    }
                },
                close: {
                    text: translations.do_cancel,
                },
            },
        });
    });

    erdsoft.initValidation();
    erdsoft.initSelectTwos();

    $('body').on('reset', '.js-form-validate-jquery', function (ev) {
        var this_form = $(this);
        var ck_fields = $('.js-ck-text', this_form);
        if (ck_fields.length > 0 && CKEDITOR) {
            $.each(ck_fields, function (key, value) {
                var this_field = $(this);
                var this_id = this_field.attr('id');
                if (CKEDITOR.instances[this_id]) {
                    CKEDITOR.instances[this_id].setData('');
                }
            });
        }

        $('.js-uploaded-files', this_form).empty();

        // also reset sliders if there is any
        var sliders = $('.js-price-slider');
        if (sliders.length > 0) {
            sliders.each(function() {
                var options = $(this).slider( 'option' );
                $(this).slider( 'values', [ options.min, options.max ] );
            });
        }
    });

    // Number widget
    $('body').on('keydown', '.js-number-input', function(e) {
        var char     = e.key,
            keyCode  = e.keyCode,
            ctrlKey  = e.ctrlKey,
            shiftKey = e.shiftKey;

        var quantity_el = $(this);
        var step = ~~parseInt(quantity_el.data('step') || 1);

        // Allow: backspace, delete, tab and escape
        if ($.inArray(keyCode, [8, 46, 9, 27]) !== -1
            // Allow dots (.)
            // On Windows numeric delete send different character (. and ,) for same keycode (110)
            || (((keyCode == 110 && char == '.') || keyCode == 190) &&
                (
                    // Disallow dots (.) at whole number
                    quantity_el.hasClass('js-decimal-number') === true
                    // Disallow multiple dots (.)
                    && quantity_el.val().replace(/[^\.]/g, '').length < 1
                )
            )
            // Allow: Ctrl+A
            || (keyCode == 65 && ctrlKey === true)
            // Allow: Ctrl+C
            || (keyCode == 67 && ctrlKey === true)
            // Allow: Ctrl+X
            || (keyCode == 88 && ctrlKey === true)
            // Allow: home, end, left, right
            || (keyCode >= 35 && keyCode <= 39)
        ) {
            // let it happen, don't do anything
            return;
        }

        // Pressing enter in a focused text input will click the first submit button in the form
        // This is standard HTML form behaviour
        // One way to avoid it is not to have any submit button in the form or create this prevention
        if (keyCode == 13) {
            quantity_el.trigger('change');
        }

        // Ensure that it is a number and stop the keypress
        if ((shiftKey || (keyCode < 48 || keyCode > 57)) && (keyCode < 96 || keyCode > 105)) {
            e.preventDefault();
        }
    })
    .on('change', '.js-number-input', function() {
        var quantity_el = $(this);
        var step = ~~parseInt(quantity_el.data('step') || 1);
        var quantity = parseFloat(quantity_el.val());

        if (isNaN(quantity) || quantity == 0) {
            quantity_el.val(step);
        }
    });

    $('body').on('click', '.js-number-widget .js-number-control', function(e) {
        e.preventDefault();

        var that = $(this);
        var quantity_el = that.parent().find('.js-number-input');
        var quantity = parseInt(quantity_el.val());
        var step = ~~parseInt(quantity_el.data('step') || 1);
        var max = quantity_el.data('max') || null;
        if (max) {
            max = ~~parseInt(max);
        }
        var min = quantity_el.data('min') || null;
        if (min) {
            min = ~~parseInt(min);
        }

        if (isNaN(quantity)) {
            quantity = 0;
        }

        if (that.hasClass('js-number-control-sub')) {
            if (quantity > step) {
                quantity -= step;
            }
            else {
                quantity = step;
            }

            if (min && min > quantity) {
                return;
            }

            quantity_el.val(quantity);
        }
        else if (that.hasClass('js-number-control-add')) {
            quantity += step;
            if (max && max < quantity) {
                return;
            }

            quantity_el.val(quantity);
        }
        quantity_el.trigger('change');
    });

    /* var priceMin = $('.js-price-min');
    var priceMax = $('.js-price-max'); */


    // $('.js-category-selected').parents('li').trigger('click');
    $('.js-category-selected').parents('li').find('> a > .js-toggle-category-subnav').trigger('click');


    // modalLoadedben is le kell venni a kommentet ha hasznalatban van!

    // Bar rating
    erdsoft.initRating();

    if ($('.js-star-rating').length > 0) {
        $('.js-star-rating').each( function() {
            var ratingElem = $(this);
            var rating = ratingElem.data('rating');
            if (typeof rating === 'undefined') {
                rating = ratingElem.val();
            }

            ratingElem.barrating({
                theme: 'css-stars',
                initialRating: rating,
            });
        });
    }

    if ($('.js-product-selector-item').length > 0) {
        $('.js-product-selector-item').on('click', function() {
            var selectedItem = $(this);
            var selectedValue = selectedItem.data('value');
            var parent = selectedItem.closest('.js-product-selector');
            parent.find('.js-product-selector-item').removeClass('product__selector-item--selected');
            selectedItem.addClass('product__selector-item--selected');
            parent.find('.js-product-selector-value').val(selectedValue);
        });
    }

    $('body').on('click', '.js-cross-item, .js-supplementary-item', function() {
        $('.js-cross-item, .js-supplementary-item').removeClass('product__box--selected');
        $(this).addClass('product__box--selected');
    });

    if ($('.js-toggle-order-details').length) {
        $('.js-toggle-order-details').on('click', function() {
            var orderItem = $(this).closest('.js-order-item');
            var orderDetails = orderItem.find('.js-order-details');
            if (orderItem.hasClass('order-history__item--open')) {
                orderDetails.slideUp(300, function() {
                    orderItem.removeClass('order-history__item--open');
                });
            } else {
                orderItem.addClass('order-history__item--open');
                orderDetails.slideDown(300);
            }
        });
    }

    erdsoft.getCache('body').on('click', '.js-password-eye', function() {
        var passControl = $(this).closest('.form__item');
        var passField = passControl.find('.js-password-field');
        var svgPassIcon;

        if (passField.hasClass('js-visible-pass')) {
            svgPassIcon = { name: 'eye' };
            passField.attr('type', 'password').removeClass('js-visible-pass');
        }
        else {
            svgPassIcon = { name: 'eye-blocked' };
            passField.attr('type', 'text').addClass('js-visible-pass');
        }
        passControl.find('.js-password-eye').html(erdsoft.svgIcon(svgPassIcon));
    });

    if ($('.js-countup').length > 0) {
        var counterDelay = 0;
        var counterElements = document.getElementsByClassName('js-counter-item');

        var observer = new IntersectionObserver(function(entries) {
            for (var i = 0; i < entries.length; i++) {
                counterDelay = 300 * i;
                if(entries[i].isIntersecting === true) {
                    observer.unobserve(entries[i].target);
                    runCounter(entries[i].target);
                }
            }
        }, { threshold: [0.1] });

        for (var i = 0; i < counterElements.length; i++) {
            observer.observe(counterElements[i]);
        }
    }

    function runCounter(element) {
        const el = $(element).find('.js-countup');
        setTimeout(function() {
            // https://inorganik.github.io/countUp.js/
            var counter = new CountUp(el[0], 0, parseInt(el.data('number')));
            counter.start();
        }, counterDelay);
    }

    $('.block__sidebar').on('click', function(e) {
        e.stopPropagation();
    });
    // erdsoft.openModal({
    //     type: 'confirm', // optional. default: dialog. ['confirm', 'alert', 'dialog', etc]
    //     title: 'Alert!',
    //     content: 'Simple alert!',
    // });

    function toggleCategoryNav (categoryNav, checkSticky = false) {
        if (!categoryNav.length > 0 && !categoryNav.find('.js-category-nav-parent')) return
        if ($('.header').hasClass('header--sticky') && checkSticky == true) return

        const categoryNavParent = categoryNav.find('.js-category-nav-parent');
        categoryNavParent.addClass('js-touched');

        const isNotOpened = !categoryNavParent.hasClass('opened');
        const isDefaultOpen = categoryNavParent.hasClass('default-open');

        if (!categoryNavParent.hasClass('megamenu')) {
            if (isNotOpened && !isDefaultOpen) {
                categoryNavParent.addClass('opened');
                categoryNav.find('.js-open-category-nav .nav__toggle').addClass('nav__toggle--rotate');
                return
            }
        } else {
            if (isNotOpened) {
                erdsoft.layoutMasonry();
                categoryNavParent.addClass('opened');
                categoryNav.find('.js-open-category-nav .nav__toggle').addClass('nav__toggle--rotate');
                return
            }
        }


        categoryNavParent.removeClass('opened default-open');
        categoryNav.find('.js-open-category-nav .nav__toggle').removeClass('nav__toggle--rotate');
    }

    if (themeSettings.open_categories_on_click) {
        $('.js-open-category-nav').append('<span class="nav__toggle">' + erdsoft.svgIcon({name: themeSettings.dropdown_arrow}) + '</span>')
    }

    $('.js-open-category-nav.js-subnav-no-hover').on('click', function() {
        toggleCategoryNav($(this).closest('.js-category-nav-wrap'));
    });

    $(document).on('click',function(e){
        let $target = $(e.target);
        if((!$target.closest('.js-open-category-nav').length && !$target.closest('.js-category-nav-parent').length) && $('.js-category-nav-parent').hasClass('opened')) {
            toggleCategoryNav($('.js-open-category-nav').closest('.js-category-nav-wrap'))
        }
    });

    $('.js-address-toggle').on('click', function() {
        var that = $(this);
        var parent = that.closest('.js-address-card');
        var address = parent.find('.js-address');

        if (parent.hasClass('address-card-collapsed')) {
            that.addClass('rotate-toggle');
            parent.removeClass('address-card-collapsed');
            address.slideDown(200);
        } else {
            that.removeClass('rotate-toggle');
            address.slideUp(200, function(){
                parent.addClass('address-card-collapsed');
            });
        }
    });

    function initSideBar() {
        var $navSidebar = $('.js-nav-sidebar');
        if (!$navSidebar.length) {
            return;
        }

        // Check if the sidebar exists first to avoid unnecessary initializations
        var $html = $('html');
        var $closeSidebar = $('.js-close-sidebar');
        var $openSidebar = $('.js-open-sidebar');
        var $openSidebarWrap = $('.js-open-sidebar-wrap');

        if ($('.selected', $navSidebar).length) {
            $openSidebarWrap.addClass('selected')
        }

        // Check if the close button exists
        if ($closeSidebar.length) {
            $closeSidebar.add($navSidebar).on('click', function(e) {
                // Check if the target is the sidebar itself or if the close button was clicked
                if (e.target === this || $(e.target).closest('.js-close-sidebar').length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    $html.removeClass('overflow');
                    $navSidebar.fadeOut(250);
                }
            });
        }

        // Check if the open button exists
        if ($openSidebar.length) {
            $openSidebar.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $html.addClass('overflow');
                $navSidebar.fadeIn(250);
            });
        }
    };

    function initMasonry($grid, itemSelector) {
        // Check if $grid and itemSelector elements exist and if masonry plugin is available
        // Also check if $grid has already been initialized
        if (!$grid.length || !$(itemSelector).length || typeof $.fn.masonry !== 'function' || $grid.hasClass('inited')) {
            return;
        }

        // Loop through each lazy-loaded image inside $grid and trigger the lazySizes loader
        $.each($grid.find('img.lazyload'), function(index, elem) {
            lazySizes.loader.unveil(elem); // Unveil the image to start loading it
        });

        // Initialize Masonry layout with specified options
        $grid.masonry({
            itemSelector: itemSelector, // Selector for grid items
            percentPosition: true,      // Use percentage-based positioning for items
            horizontalOrder: true,      // Maintain horizontal order of items
            gutter: 0                   // No gutter between items
        });

        // Add 'inited' class to $grid to mark it as initialized
        $grid.addClass('inited');
    }

    $('.js-filter-link').on('click', function() {
        var this_cat = $(this);
        var this_cat_id = this_cat.data('category');
        var matched_cats = $('.js-filter-link[data-category="' + this_cat_id + '"]');

        if(!this_cat.hasClass('active')) {
            matched_cats.addClass('active');
        }
        else {
            matched_cats.removeClass('active');
        }
    });

    if (window.google_tag_manager && (typeof forceOpenCookieBar != 'undefined') && forceOpenCookieBar === true) {
        $('.js-toggle-cookie-panel').trigger('click');
    }

    initMasonry($('.js-masonry'), '.js-masonry > li')
    initSideBar();
    erdsoft.callScripts();
});
